<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right">
        <headerbuttonstack :state="sideButtons" />
      </div>
    </div>
    <div
      style="
        font-size: 32px;
        text-align: left;
        color: #e51550;
        border-bottom: 1px solid #ccc;
        padding: 5px;
        font-weight: 400;
        margin-bottom: 25px;
      "
    >
        {{ $t('settings.wage.customWageTypesConfigurator') }}
    </div>

    <div v-if="loading">
      <i class="fas fa-spinner fa-spin" style="font-size: xxx-large"></i>
      <br />
      <br />
        {{ $t('settings.wage.loadingCustomWageTypes') }}
    </div>
    <div v-else>
      <div>
        <table class="styled-table">
            <tr>
                <th v-if="[2,3,4,5,6].includes(externalSoftware)" v-on:click="sort('numberString')">
                    Sotec ID
                    <i class="fas"
                       :class="{ 'fa-sort-up': sortBy === 'numberString' && sortOrder === 1, 'fa-sort-down': sortBy === 'numberString' && sortOrder === -1}"></i>
                </th>
                <th v-else v-on:click="sort('numberString')">
                    {{ $t('settings.groups.number') + ' ' }}
                    <i class="fas"
                       :class="{ 'fa-sort-up': sortBy === 'numberString' && sortOrder === 1, 'fa-sort-down': sortBy === 'numberString' && sortOrder === -1}"></i>
                </th>
                <th v-on:click="sort('exportId')">
                    Export ID
                    <i class="fas"
                       :class="{ 'fa-sort-up': sortBy === 'exportId' && sortOrder === 1, 'fa-sort-down': sortBy === 'exportId' && sortOrder === -1}"></i>
                </th>
                <th v-on:click="sort('name')">
                    {{ $t('settings.groups.name') + ' ' }}
                    <i class="fas"
                       :class="{ 'fa-sort-up': sortBy === 'name' && sortOrder === 1, 'fa-sort-down': sortBy === 'name' && sortOrder === -1}"></i>
                </th>
                <th v-on:click="sort('enabledStores')">
                    {{ $t('settings.wage.locations') }}
                    <i class="fas"
                       :class="{ 'fa-sort-up': sortBy === 'enabledStores' && sortOrder === 1, 'fa-sort-down': sortBy === 'enabledStores' && sortOrder === -1}"></i>
                    <button class="icon-button" v-on:click.stop="OpenFilterDropdown()">
                        <i class="fas fa-filter"></i>
                    </button>
                </th>
                <th>{{ $t('settings.groups.color') }}</th>
                <th class="center">
                    {{ $t('settings.wage.wageTypeDetails') }}
                </th>
                <th class="center">
                    {{ $t('settings.ui.edit') }}
                </th>
            </tr>
          <tr v-for="x in filteredIndividualWageTypes" v-bind:key="x.id" style="margin:0px;">
            <td>{{ x.numberString }}</td>
            <td>{{ x.exportId }}</td>
            <td>{{ x.name }}</td>
              <td>
                  {{ x.details ? (!x.details.enabledStores ? $t('settings.wage.allLocations') : printStoreNames(x.details.enabledStores)) : "-" }}
              </td>
              <td class="center" style="display: flex; align-items: center; align-content: center; padding:9px 0px 8px 0px;">
              <div
                style="
                  width: 15px;
                  height: 15px;
                  background-color: #f00;
                  text-align: center;
                  cursor: pointer;
                  margin: 10px 0px 10px 22px;
                "
                v-bind:style="{ 'background-color': x.color }"
                v-on:click="toggleColorPicker(x)"
              ></div>
            </td>
            <td class="center">
              <i
                class="fas fa-circle-exclamation"
                v-if="!x.details"
                v-tooltip="$t('settings.wage.noCalculationDetailsYet')"
                style="color: var(--ml)">&nbsp;</i>
              <button class="icon-button" v-on:click="openEditEntityDetails(x)">
                <i class="fas fa-edit"></i>
              </button>
            </td>
            <td class="center">
              <button class="icon-button" v-on:click="openEditEntity(x)">
                <i class="fas fa-edit"></i>
              </button>
            </td>
          </tr>
        </table>
      </div>
      <br />
      <hr />
      <h4>{{ $t('settings.wage.exportMappingTable') }}</h4>
      <MappingEmploymentModelWageTypes ref="child"></MappingEmploymentModelWageTypes>
    </div>

    <b-modal size="md" ref="modal-loading" :no-close-on-backdrop="true" :no-close-on-esc="true" centered>
      <template slot="modal-header">
        <div></div>
      </template>
      <b-container fluid>
        <div class="full">
          <div class="label left" style="text-align: center">
            <i class="fas fa-spinner fa-spin" style="font-size: xxx-large"></i> <br/><br/>
              {{ $t('settings.wage.pleaseWait') }}<br />
              {{ $t('settings.wage.loadingData') }}<br />
          </div>
        </div>
      </b-container>
      <template slot="modal-footer">
        <div></div>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import button from "../uicomponents/button.vue";
import MappingEmploymentModelWageTypes from "./MappingEmploymentModelWageTypes.vue";

export default {
  components: { button, MappingEmploymentModelWageTypes },
  name: "IndividualWageTypes",
  data() {
    return {
      loading: true,
      saves: false,
      individualWageTypes: [],
      individualWageTypesTrashed: [],
      mdWagetypes: [],
      stores: [],
      storeCountries: [],
      mdCollectiveContracts: [],
      spots: [],
      storeLocations: [],
      mdBonusPaymentSettings: [],

      allowedContractMapFlat: {},
      allowedContractMap: {},
      contractCollectiveAgreements: {},
      contractWageGroups: [],
      employeeCategoryMap: {},
      employeeLevelMap: {},
      contractTypeMap: {},
      employmentTypeMap: {},
      paymentTypeMap: {},
      wageTypeMap: {},
      nightWorkerTypeMap: {},
      nightWorkModeMap: {},
      exitReasonMap: {},

      filterDropdownOptions: [],
      refreshFilteredList: 0,
      sortBy: "numberString",
      sortOrder: 1,
    };
  },
  created: function () {
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {
      // this.refresh();
    }
  },
  mounted: function () {
    console.log("MOUNTED");
    this.setupUIDataMaps();
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters(["companyId", "countryEnumMap", "uiDataMap", "isSuperUser", "companyArray", "externalSoftware", "employeeMap"]),
    headerButtons() {
      let view = this;

      let state = {
        buttons: [],
          helperLinks: [
              {
                  title: view.$t('settings.wage.customWageTypesTitle'),
                  helperText: view.$t('settings.wage.customWageTypesHelpText'),
                  externalUrl:
                      "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/3130720268",
                  externalLabel: view.$t('settings.wage.learnMore'),
                  cancelLabel: view.$t('settings.wage.thanks'),
                  icon: "fa-file-export"
              },
              {
                  title: view.$t('settings.wage.getSupport'),
                  helperText: view.$t('settings.wage.getSupportHelpText'),
                  externalUrl:
                      "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11",
                  externalLabel: view.$t('settings.sync.contactSupport'),
                  cancelLabel: view.$t('global.ui.close')
              }
          ]
      };
      state.buttons.push({
        type: "block",
        icon: "fa-refresh",
        disabled: view.loading,
        click: () => {
          view.refresh();
        },
          tooltip: view.$t('settings.wage.reloadData')
      });
      state.buttons.push({
        type: "block",
        icon: "fa-plus",
        disabled: view.loading,
        click: ($event) => {
          view.openNewWageType($event);
        },
          tooltip: view.$t('settings.wage.createNew')
      });
      state.buttons.push({
        type: "block md",
        icon: "fa-file-import",
        disabled: view.loading,
        click: ($event) => {
          view.openImportMdBonusPaymentSettings($event);
        },
          tooltip: view.$t('settings.wage.importBonusSettingsFromMd')
      });
      state.buttons.push({
        type: "block ml",
        icon: "fa-file-import",
        disabled: view.loading,
        show: view.companyArray.length > 1,
        click: ($event) => {
          view.openImportBonusPaymentSettingsFromCompanySelect($event);
        },
          tooltip: view.$t('settings.wage.importCustomWageTypesFromCompany')
      });
      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [
          {
            type: "block",
            icon: "fa-trash-restore",
            disabled: view.loading || view.individualWageTypesTrashed.length == 0,
            click: () => {
              view.openRestoreIwtPopup();
            },
              tooltip: view.$t('settings.wage.restoreCustomWageTypes'),
          }
        ],
      };
      state.buttons.push();
      return state;
    },
    filteredIndividualWageTypes() {
      let view = this;
      view.refreshFilteredList; // to trigger recompute

      let toggledFilterOptions = view.filterDropdownOptions.filter(f => f.toggled).map(f => f.key);

      let filteredList = [];
      view.individualWageTypes.forEach(iwt => {
        if (!iwt.details || !iwt.details.enabledStores) {
          // no store restriction, always show
          filteredList.push(iwt);
        } else {
          let enabledStores = JSON.parse(iwt.details.enabledStores);
          if (enabledStores.length === 0 && toggledFilterOptions.includes("none")) {
            // no stores enabled, only show if "no stores" is toggled
            filteredList.push(iwt);
          } else if (enabledStores.some(es => toggledFilterOptions.includes(es))) {
            filteredList.push(iwt);
          }
        }
      });

      if (view.sortBy == "enabledStores") {
        filteredList.sort((a, b) => {
          const numA = a.details ? (a.details.enabledStores ? JSON.parse(a.details.enabledStores)[0] : 0) : Infinity;
          const numB = b.details ? (b.details.enabledStores ? JSON.parse(b.details.enabledStores)[0] : 0) : Infinity;

          if (numA == numB) {
            return a.name.localeCompare(b.name) * view.sortOrder;
          }
          return (numA - numB) * view.sortOrder;
        });
      } else {
        filteredList.sort((a, b) => {
          const numA = a[view.sortBy] && parseFloat(a[view.sortBy]) ? parseFloat(a[view.sortBy]) : (a[view.sortBy] == "0" ? 0 : Infinity);
          const numB = b[view.sortBy] && parseFloat(b[view.sortBy]) ? parseFloat(b[view.sortBy]) : (b[view.sortBy] == "0" ? 0 : Infinity);

          if (numA == numB) {
            if (a[view.sortBy] == b[view.sortBy]) {
              return a.name.localeCompare(b.name) * view.sortOrder;
            }
            return a[view.sortBy].localeCompare(b[view.sortBy]) * view.sortOrder;
          }
          return (numA - numB) * view.sortOrder;
        });
      }

      return filteredList;
    },
  },
  watch: {
    companyId: function (val, oldVal) {
      this.filterDropdownOptions = [];
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
      view.loading = true;

      if (view.$refs["child"]) {
        view.$refs["child"].refresh();
      }

      let promises = [];

      promises.push(view.$helpers.GetStoresSettings(true).then((response) => {
        view.stores = response.data;
        // console.log("stores", view.stores);

        let subPromises = [];

        view.stores.forEach(s => {
          if(!view.storeCountries.includes(s.country)){
            view.storeCountries.push(s.country);
          }
          subPromises.push(view.loadAllowedContracts(s.id));
        });
        view.LoadFilterDropdown();
        return Promise.all(subPromises);
      }));

      promises.push(view.loadWageTypes());
      promises.push(view.loadIndividualWageTypes());
      promises.push(view.loadTrashedIndividualWageTypes());
      promises.push(view.loadMdCollectiveContracts());
      promises.push(view.loadMlContractCollectiveAgreements());
      promises.push(view.loadSpots());
      promises.push(view.loadStoreLocations());
      promises.push(view.$helpers.GetEmployeeMap());
      promises.push(view.$helpers.GetCountryEnum());

      Promise.all(promises)
        .then(() => {

          // filter data
          let uniqueCCsByAllowedContracts = [];
          Object.values(view.allowedContractMapFlat).forEach(ac => {
            if (!ac.active) {
              return;
            }

            if (!uniqueCCsByAllowedContracts.includes(ac.collectiveContractId)) {
              uniqueCCsByAllowedContracts.push(ac.collectiveContractId);
            }
          });
          view.mdCollectiveContracts = view.mdCollectiveContracts.filter(cc => uniqueCCsByAllowedContracts.includes(cc.id));
          // console.log("mdCollectiveContracts", view.mdCollectiveContracts);
          let uniqueMlContractCollectiveAgreementIds = [...new Set(view.mdCollectiveContracts.map(cc => cc.mlCollectiveAgreementId).filter(v => v != null))];
          // console.log("colletiveAgreementIds", uniqueMlContractCollectiveAgreementIds);
          view.contractCollectiveAgreements = Object.values(view.contractCollectiveAgreements).filter(ca => uniqueMlContractCollectiveAgreementIds.includes(ca.id));
          // console.log(view.contractCollectiveAgreements);
          view.contractWageGroups = view.contractCollectiveAgreements.reduce((array, ca) => {
            ca.wage_groups.forEach(wg => {
              if (uniqueMlContractCollectiveAgreementIds.length > 1) {
                wg.name = wg.name + " (" + ca.name + ")";
              }
              array.push(wg);
            });
            return array;
          }, []);
          // console.log(view.contractWageGroups);

          console.log("loading done");
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          view.loading = false;
        });
    },
    loadIndividualWageTypes: function () {
      let view = this;
      let params = {};

      return view.$helpers
        .GetCall("/api/sec/individualWageTypes", params)
        .then((response) => {
          let data = response.data.data;

          // Sorting the data by numberString before further processing
          data.sort((a, b) => {
            // Handle cases where numberString might be undefined or null
            const numA = a.numberString && parseFloat(a.numberString) ? parseFloat(a.numberString) : (a.numberString == "0" ? 0 : Infinity);
            const numB = b.numberString && parseFloat(b.numberString) ? parseFloat(b.numberString) : (b.numberString == "0" ? 0 : Infinity);

            if (numA == numB) {
              if (a.numberString == b.numberString) {
                return a.name.localeCompare(b.name);
              }
              return a.numberString.localeCompare(b.numberString);
            }
            return numA - numB;
          });

          let tmp = [];
          // Looping through sorted data and creating objects
          for (let i = 0; i < data.length; i++) {
            let item = {
              id: data[i].id,
              numberString: data[i].numberString,
              exportId: data[i].exportId,
              name: data[i].name,
              sorting: data[i].sorting,
              color: data[i].color,
              details: data[i].details,
            };
            tmp.push(item);
          }
          view.individualWageTypes = tmp;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loadTrashedIndividualWageTypes: function () {
      let view = this;
      let params = {};

      return view.$helpers
        .GetCall("/api/sec/individualWageTypes/trashed", params)
        .then((response) => {
          view.individualWageTypesTrashed = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loadWageTypes: function () {
      let view = this;
      let url = "/api/sec/wagetypes";
      let params = {};
      return view.$helpers
        .GetCall(url, params)
        .then((response) => {
          let data = response.data;
          let tmp = [];
          for (let i = 0; i < data.length; i++) {
            let item = {
              id: data[i].id,
              key: data[i].key,
              name: data[i].name
            };
            tmp.push(item);
          }
          view.mdWagetypes = tmp.slice();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadMdCollectiveContracts: function () {
      let view = this;
      let url = "/api/sec/proxy/md/collectiveContracts";
      let params = {};
      return view.$helpers
        .GetCall(url, params)
        .then((response) => {
          let data = response.data;
          let tmp = [];
          for (let i = 0; i < data.length; i++) {
            tmp.push(data[i]);
          }
          tmp.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          view.mdCollectiveContracts = tmp.slice();
          // console.log(view.mdCollectiveContracts);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadAllowedContracts(storeId) {
      let params = {
        storeId: storeId
      };
      return this.$helpers.GetCall('/api/sec/proxy/md/allowedContracts', params).then((response) => {
        let map = {};
        response.data.forEach(allowedContract => {
          map[allowedContract.id] = allowedContract;
          this.allowedContractMapFlat[allowedContract.id] = allowedContract;
        });
        this.allowedContractMap[storeId] = map;
        return new Promise((resolve, reject) => {
          resolve(this.$helpers.returnObj(map, false));
        });
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      });
    },
    // collective agreements
    loadMlContractCollectiveAgreements() {
      let view = this;

      let url = '/api/sec/contract/collectiveAgreement';
      const params = {
        companyId: this.$store.state.companyId,
      };

      return this.axios({
        method: 'get',
        headers: { 'AUTHORIZATION': "Bearer "+this.$store.state.jwt },
        url: url,
        params
      }).then((response) => {
        view.contractCollectiveAgreements = {};
        view.contractWageGroups = [];
        response.data.forEach(r => {
          view.contractCollectiveAgreements[r.id] = r;
        });
        // console.log(view.selectedCollectiveAgreement);
        // console.log(view.contractCollectiveAgreements);
      }).catch((error) => {
        console.log(error);
          view.$helpers.error(
              view.$t('settings.wage.errorLoadingCollectiveAgreements'),
              view.$t('settings.wage.couldNotLoadCollectiveAgreements')
          );
      });
    },
    loadSpots: function () {
      let view = this;
      let url = "/api/sec/proxy/md/spots";
      let params = {};
      return view.$helpers
        .GetCall(url, params)
        .then((response) => {
          // console.log(response.data.data);
          let data = response.data.data;
          let tmp = [];
          Object.values(data).forEach((spot) => {
            tmp.push(spot);
          });
          view.spots = tmp.slice();
          // console.log("spots", view.spots);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadStoreLocations: function () {
      let view = this;
      let url = "/api/sec/proxy/md/storeLocations";
      let params = {};
      return view.$helpers
        .GetCall(url, params)
        .then((response) => {
          // console.log(response.data);
          let data = response.data;
          let tmp = [];
          Object.values(data).forEach((loc) => {
            tmp.push(loc);
          });
          view.storeLocations = tmp.slice();
          // console.log("storeLocations", view.storeLocations);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadMdBonusPaymentSettings: function () {
      let view = this;
      let url = "/api/sec/proxy/md/bonuspaymentsettings";
      let params = {};
      return view.$helpers
        .GetCall(url, params)
        .then((response) => {
          let data = response.data.data;
          let tmp = [];
          console.log(data);
          Object.values(data).forEach((storeBonusPaymentSetting) => {
            storeBonusPaymentSetting.forEach((bonusPaymentSetting) => {
              tmp.push(bonusPaymentSetting);
            });
          });
          tmp.sort((a, b) => {
            if (a.storeId === b.storeId) {
              return a.name.localeCompare(b.name);
            } else {
              return a.storeId - b.storeId;
            }
          });
          // console.log(tmp);
          view.mdBonusPaymentSettings = tmp.slice();
          return view.mdBonusPaymentSettings;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadBonusPaymentSettingsFromCompany: function (companyId) {
      let view = this;
      let url = "/api/sec/individualWageTypes/getForCompany";
      let params = {
        foreignCompanyId: companyId,
      };
      return view.$helpers
        .GetCall(url, params)
        .then((response) => {
          let data = response.data.data;
          let tmp = [];
          // console.log(data);
          return data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadWageGroups: function () {
      let view = this;
      let url = "/api/sec/proxy/md/storeLocations";
      let params = {};
      return view.$helpers
        .GetCall(url, params)
        .then((response) => {
          // console.log(response.data);
          let data = response.data;
          let tmp = [];
          Object.values(data).forEach((loc) => {
            tmp.push(loc);
          });
          view.storeLocations = tmp.slice();
          // console.log("storeLocations", view.storeLocations);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openNewWageType(event) {
      let view = this;
      let dataEntries = [
        {
          label: [2,3,4,5,6].includes(view.externalSoftware) ? "Sotec ID" : view.$t('settings.groups.number'),
          key: "numberString",
          hidden: false,
          type: "text",
          value: "",
          length: 5,
          styles: { width: "350px" },
        },
        {
          label: "Export ID",
          key: "exportId",
          hidden: false,
          type: "text",
          value: "",
          length: 5,
          styles: { width: "350px" },
        },
        {
          label: view.$t('settings.groups.name'),
          key: "name",
          hidden: false,
          type: "text",
          value: "",
          length: 128,
          styles: { width: "350px" },
        },
        //{label: 'Sortierungs Priorität', key: 'priority', hidden: false, type: 'slider', value: 1, slider: {value: 1, min: 1, max: 100}},
        { flexDivider: true, styles: { "margin-bottom": "23px" } },
      ];
      this.$helpers.OpenPopup({
        elRelative: event.currentTarget,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          selectCallback: function (newWageType) {
            view.createIndividualWageType(newWageType);
          },
          errorCheck: {
            'numberString': (entries) => {
              let key = "numberString";
              let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
              if (!entries.hasOwnProperty('numberString') || entries.numberString === '') {
                return {
                  key: key,
                  label: label,
                  type: 'error',
                  text: view.$t('settings.wage.mustBeProvided')
                }
              // } else if (view.employmentModels.find(f => parseInt(f.number) === parseInt(entries.number))) {
              //   return {
              //     key: key,
              //     label: label,
              //     type: 'error',
              //     text: 'Wird bereits verwendet'
              //   }
              } else {
                return null;
              }
            },
            'exportId': (entries) => {
              let key = "exportId";
              let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
              if (!entries.hasOwnProperty('exportId') || entries.exportId === '') {
                return {
                  key: key,
                  label: label,
                  type: 'error',
                  text: view.$t('settings.wage.mustBeProvided')
                }
              } else {
                return null;
              }
            },
            'name': (entries) => {
              // console.log(entries.name);
              let key = "name";
              let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
              if (entries.name == undefined || entries.name == "") {
                  return {
                    key: key,
                    label: label,
                    type: "error",
                    text: view.$t('settings.wage.pleaseFillOut'),
                  };
              } else if (view.individualWageTypes.find((f) => f.name.toLowerCase() === entries.name.toLowerCase()))
                return {
                  key: key,
                  label: label,
                  type: "error",
                  text: view.$t('settings.groups.errAlreadyUsed'),
                };
              else return null;
            },
          },
        },
        header: view.$t('settings.wage.createNewWageType'),
        remainAfterSelect: false,
        expanded: true,
      });
    },
    openEditEntity(entity) {
      let view = this;

      let dataEntries = [
        {
          label: "id: ",
          key: "id",
          hidden: true,
          type: "text",
          value: entity.id,
          length: 128,
          styles: { width: "350px" },
        },
        {
          label: [2,3,4,5,6].includes(view.externalSoftware) ? "Sotec ID" : view.$t('settings.groups.number'),
          key: "numberString",
          hidden: false,
          type: "text",
          value: entity.numberString,
          length: 5,
          styles: { width: "350px" },
        },
        {
          label: "Export ID",
          key: "exportId",
          hidden: false,
          type: "text",
          value: entity.exportId,
          length: 5,
          styles: { width: "350px" },
        },
        {
          label: view.$t('settings.groups.name'),
          key: "name",
          hidden: false,
          type: "text",
          value: entity.name,
          length: 128,
          styles: { width: "350px" },
        },
        //{label: 'Sortierungs Priorität', key: 'priority', hidden: false, type: 'slider', value: wt.sorting, slider: {value: wt.sorting, min: 1, max: 100}},
        { flexDivider: true, styles: { "margin-bottom": "23px" } },
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          selectCallback: function (eEntity) {
            view.editEntity(eEntity);
          },
          deleteCallback: function (eEntity) {
            view.openDeleteIwtPopup(eEntity);
          },
          errorCheck: {
            // numberString: (entries) => {
            //   if (
            //     entries.hasOwnProperty("numberString") &&
            //     view.individualWageTypes.find(
            //       (f) =>
            //         f.numberString !== entity.numberString &&
            //         f.numberString === entries.numberString
            //     )
            //   )
            //     return {
            //       key: "numberString",
            //       type: "error",
            //       text: "Wird bereits verwendet",
            //     };
            //   else return null;
            // },
            name: (entries) => {
              if (
                entries.hasOwnProperty("name") &&
                view.individualWageTypes.find((f) => f.name !== entity.name && f.name === entries.name)
              )
                return {
                  key: "name",
                  type: "error",
                  text: view.$t('settings.groups.errAlreadyUsed'),
                };
              else return null;
            },
          },
        },
        header: view.$t('settings.wage.editWageType'),
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
    openEditEntityDetails(entity) {
      console.log(entity);
      let view = this;

      if(entity.id == 18){
        let dataEntries = [
          {
            label: "",
            key: "numberString",
            hidden: false,
            type: "output",
              value: view.$t('settings.wage.valueAlways78Hours'),
          }
        ];
        this.$helpers.OpenPopup({
          elRelative: null,
          type: "datafill",
          pointerDirection: 0,
          componentState: {
              positiveButtonLabel: view.$t('settings.wage.closePopup'),
            entries: dataEntries,
            selectCallback: function (eWageType) {
            },
          },
          header: view.$t('settings.wage.information'),
          remainAfterSelect: false,
          centered: true,
          expanded: true,
        });
        return;
      }
      if(entity.id == 155 || entity.id == 156){
        let dataEntries = [
          {
            label: "",
            key: "numberString",
            hidden: false,
            type: "output",
              value: view.$t('settings.wage.valueAlways1Hour')
          }
        ];
        this.$helpers.OpenPopup({
          elRelative: null,
          type: "datafill",
          pointerDirection: 0,
          componentState: {
              positiveButtonLabel: view.$t('settings.wage.closePopup'),
            entries: dataEntries,
            selectCallback: function (eWageType) {
            },
          },
          header: view.$t('settings.wage.information'),
          remainAfterSelect: false,
          centered: true,
          expanded: true,
        });
        return;
      }

      let bonusTypes = [
          { value: 0, label: view.$t('settings.wage.bonusNone') },
          { value: 1, label: view.$t('settings.wage.bonusWith') },
          { value: 2, label: view.$t('settings.wage.bonusOnly') }
      ]
      let bonusModeItems = [
          {
              "label": view.$t('enum.bonusMode.1'),
              "value": 1,
              "alwaysShow": false
          },
          {
              "label": view.$t('enum.bonusMode.2'),
              "value": 2,
              "alwaysShow": true
          },
          {
              "label": view.$t('enum.bonusMode.3'),
              "value": 3,
              "alwaysShow": true
          },
          {
              "label": view.$t('enum.bonusMode.4'),
              "value": 4,
              "alwaysShow": false
          },
          {
              "label": view.$t('enum.bonusMode.5'),
              "value": 5,
              "alwaysShow": false
          },
          {
              "label": view.$t('enum.bonusMode.6'),
              "value": 6,
              "alwaysShow": false
          },
          {
              "label": view.$t('enum.bonusMode.7'),
              "value": 7,
              "alwaysShow": false
          },
      ];
      let bonusModeItemsFiltered = bonusModeItems.filter(bm => {
        if (entity.details && entity.details.workType != 0) {
          return bm.alwaysShow;
        } else {
          return true;
        }
      });
      // console.log("bonusModeItems", bonusModeItems);
      // console.log("entity.details.workType", entity.details ? entity.details.workType : "no details");
      // console.log("bonusModeItemsFiltered", bonusModeItemsFiltered);

      let workTypes = [
          { value: 0, label: view.$t('settings.wage.workTypeWorkingTime') },
          { value: 1, label: view.$t('settings.wage.workTypeAbsence') },
          { value: 2, label: view.$t('settings.wage.workTypeOtherCosts') },
          { value: 3, label: view.$t('settings.wage.workTypeBonusPayment') },
          { value: 4, label: view.$t('settings.wage.workTypeMonthlyTotals') },
          { value: 5, label: view.$t('settings.wage.workTypeMonthlyClosing') }
      ];
      let mdEmployeeAvailabilityTypes = view.$helpers.GetMdEmployeeAvailabilityTypes();
      let mdEmployeeAvailabilitySubTypes = view.$helpers.GetMdEmployeeAvailabilitySubTypes();
      mdEmployeeAvailabilitySubTypes.sort((a, b) => a.label.localeCompare(b.label));
      let mdStoresEnabled = [];
      for (let i = 0; i < view.stores.length; i++) {
        mdStoresEnabled.push({ value: view.stores[i].id, label: view.stores[i].name });
      }
      let extraCostTypes = [
          { value: 1,  label: view.$t('settings.wage.extraCostStaffMeal') },
          { value: 2,  label: view.$t('settings.wage.extraCostLocker') },
          { value: 10, label: view.$t('settings.wage.extraCostAdvance') },
          { value: 11, label: view.$t('settings.wage.extraCostRent') },
          { value: 12, label: view.$t('settings.wage.extraCostFine') },
          { value: 14, label: view.$t('settings.wage.extraCostWorkShoes') },
          { value: 15, label: view.$t('settings.employ.key') }, // keep existing
          { value: 16, label: view.$t('settings.wage.extraCostLearningMaterial') },
          { value: 17, label: view.$t('settings.wage.extraCostProcessingFee') },
          { value: 20, label: view.$t('settings.wage.extraCostClothingDeduction') },
          { value: 22, label: view.$t('settings.wage.extraCostClothingDeposit') },
          { value: 23, label: view.$t('settings.wage.extraCostContractPenalty') },
          { value: 0,  label: view.$t('settings.wage.extraCostOther') }
      ];
      let bonusExpenseTypes = [
          { value: 2,  label: view.$t('settings.wage.bonusExpenseLocker') },
          { value: 3,  label: view.$t('settings.wage.bonusExpenseNightWork') },
          { value: 4,  label: view.$t('settings.wage.bonusExpenseWeekendWork') },
          { value: 5,  label: view.$t('settings.wage.bonusExpenseHolidayPay') },
          { value: 6,  label: view.$t('settings.wage.bonusExpenseOnCall') },
          { value: 7,  label: view.$t('settings.wage.bonusExpenseChristmasBonus') },
          { value: 8,  label: view.$t('settings.wage.bonusExpenseTariffAllowance') },
          { value: 9,  label: view.$t('settings.wage.bonusExpensePremium') },
          { value: 10, label: view.$t('settings.wage.bonusExpenseAdvance') },
          { value: 13, label: view.$t('settings.wage.bonusExpenseVacationPayout') },
          { value: 15, label: view.$t('settings.employ.key') }, // keep existing
          { value: 18, label: view.$t('settings.wage.bonusExpenseManagementBonus') },
          { value: 19, label: view.$t('settings.wage.bonusExpenseTravelAllowance') },
          { value: 21, label: view.$t('settings.wage.bonusExpenseCrewBonus') },
          { value: 22, label: view.$t('settings.wage.bonusExpenseClothingDeposit') },
          { value: 24, label: view.$t('settings.wage.bonusExpenseStandbyAllowance') },
          { value: 25, label: view.$t('settings.wage.bonusExpenseMealAllowance') },
          { value: 0,  label: view.$t('settings.wage.bonusExpenseOther') }
      ];

      let conditionJoinModes = [
          { label: view.$t('settings.wage.joinAnd'), value: true },
          { label: view.$t('settings.wage.joinOr'), value: false }
      ];
      let holidayModes = [
          { value: 0, label: view.$t('settings.wage.holidayModeAllDays') },
          { value: 1, label: view.$t('settings.wage.holidayModeOnlyHolidays') },
          { value: 2, label: view.$t('settings.wage.holidayModeNoHolidays') }
      ];
      let holidayTypes = [
          {value: 1, label: view.$t('settings.wage.holidayLegal')},
          {value: 2, label: view.$t('settings.wage.holidayContractual')},
          {value: 3, label: view.$t('settings.wage.holidayBank')}
      ].map(ht => {
          let selected = true;
          if (entity && entity.details && entity.details.holidayTypes) {
              selected = JSON.parse(entity.details.holidayTypes).includes(ht.value);
          }
        return {...ht, selected: selected};
      });

      let mdWageTypeHourModTypes = [
          { value: 1, label: view.$t('settings.wage.modPercentual') },
          { value: 2, label: view.$t('settings.wage.modAddHours') },
          { value: 3, label: view.$t('settings.wage.modReduceHours') },
          { value: 4, label: view.$t('settings.wage.modMaximum') },
          { value: 5, label: view.$t('settings.wage.modMinimum') }
      ];

        // console.log("mdCollectiveContracts", view.mdCollectiveContracts);
      // console.log("storeCountries", view.storeCountries);

      let employeeItems = Object.values(view.employeeMap).sort((a, b) => {
        if (a.lastName == b.lastName) {
          return a.firstName.localeCompare(b.firstName);
        }
        return a.lastName.localeCompare(b.lastName);
      }).map(i => {
        let selected = false;
        if (entity && entity.details && entity.details.employeeIds) {
          selected = JSON.parse(entity.details.employeeIds).includes(i.id);
        }
        return { label: i.lastName.toUpperCase() + " " + i.firstName, value: i.id, data: i, selected: selected };
      });
      let ccItems = view.mdCollectiveContracts.filter(i=> view.storeCountries.includes(i.country)).map(i => {
        let selected = false;
        if (entity && entity.details && entity.details.collectiveContractIds) {
          selected = JSON.parse(entity.details.collectiveContractIds).includes(i.id);
        }
        if (view.storeCountries.length > 1) {
          return { label: i.name + " (" + view.countryEnumMap[i.country].key + ")", value: i.id, data: i, selected: selected };
        } else {
          return { label: i.name, value: i.id, data: i, selected: selected };
        }
      });
      // ccItems.push({label: "Kein Vertragsmodell", value: null});
      let wgItems = view.contractWageGroups.map(i => {
        let selected = false;
        if (entity && entity.details && entity.details.wageGroupIds) {
          selected = JSON.parse(entity.details.wageGroupIds).includes(i.id);
        }
        // console.log("wg item", { label: i.name, value: i.id, data: i, selected: selected });
        return { label: i.name, value: i.id, data: i, selected: selected };
      });
      let wgBonusItems = view.contractWageGroups.map(i => {
        return { label: i.name, value: i.id };
      });

      let unitsById = view.spots.reduce((map, spot) => {
        if (spot.isMain) {
          map[spot.unitId] = spot;
        }
        return map;
      }, {});
      let unitItems = Object.values(unitsById).map(i => {
        let selected = false;
        if (entity && entity.details && entity.details.shiftUnitIds) {
          selected = JSON.parse(entity.details.shiftUnitIds).includes(i.unitId);
        }
        let label = i.name;
        if (view.stores.length > 1) {
          label = label + " (" + (view.stores.find(s => s.id == i.storeId) ? view.stores.find(s => s.id == i.storeId).name : "") + ")";
        }
        return { label: label, value: i.unitId, data: i, selected: selected };
      });
      unitItems.sort((a, b) => a.label.localeCompare(b.label));

      let spotItems = view.spots.filter(i => view.stores.find(s => s.id == i.storeId) !== undefined).map(i => {
        let selected = false;
        if (entity && entity.details && entity.details.spotIds) {
          selected = JSON.parse(entity.details.spotIds).includes(i.id);
        }
        let label = i.name;
        if (!i.isMain && unitsById[i.unitId]) {
          label = unitsById[i.unitId].name + ": " + label;
        }
        if (view.stores.length > 1) {
          return { label: label + " (" + (view.stores.find(s => s.id == i.storeId) ? view.stores.find(s => s.id == i.storeId).name : "") + ")", value: i.id, data: i, selected: selected };
        } else {
          return { label: label, value: i.id, data: i, selected: selected };
        }
      });
      spotItems.sort((a, b) => a.label.localeCompare(b.label));
      // spotItems.push({label: "Keine Position", value: null});

      let shiftSpotItems = view.spots.filter(i => view.stores.find(s => s.id == i.storeId) !== undefined).map(i => {
        let selected = false;
        if (entity && entity.details && entity.details.shiftSpotIds) {
          selected = JSON.parse(entity.details.shiftSpotIds).includes(i.id);
        }
        let label = i.name;
        if (!i.isMain && unitsById[i.unitId]) {
          label = unitsById[i.unitId].name + ": " + label;
        }
        if (view.stores.length > 1) {
          return { label: label + " (" + (view.stores.find(s => s.id == i.storeId) ? view.stores.find(s => s.id == i.storeId).name : "") + ")", value: i.id, data: i, selected: selected };
        } else {
          return { label: label, value: i.id, data: i, selected: selected };
        }
      });
      shiftSpotItems.sort((a, b) => a.label.localeCompare(b.label));
      // shiftSpotItems.unshift({label: "Keine Position", value: null, data: null, selected: entity && entity.details && entity.details.shiftSpotIds && entity.details.shiftSpotIds.includes(null) });

      let fromLocationItems = view.storeLocations.map(l => l.name).filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => a.localeCompare(b)).map(i => {
        let selected = false;
        if (entity && entity.details && entity.details.fromLocationIds) {
          let locationsForName = view.storeLocations.filter(sl => sl.name === i).map(sl => sl.id);
          selected = JSON.parse(entity.details.fromLocationIds).some(id => locationsForName.includes(id));
        }
        return { label: i, value: i, selected: selected };
      });
      fromLocationItems.unshift({label: view.$t('settings.centers.noStore'), value: null, selected: entity && entity.details && entity.details.fromLocationIds && JSON.parse(entity.details.fromLocationIds).includes(null) });


      let contractTypeItems = Object.entries(view.contractTypeMap).map(([id, label]) => {
          return {
              label: view.$t(`enum.contractType.${id}`),
              value: id,
              selected: entity.details && entity.details.contractTypes ? Object.values(entity.details.contractTypes).includes(id) : false
          }
      });
      let employeeCategoryItems = Object.entries(view.employeeCategoryMap).map(([id, label]) => {
          return {
              label: view.$t(`enum.employeeCategory.${id}`),
              value: id,
              selected: entity.details && entity.details.employeeCategories ? Object.values(entity.details.employeeCategories).includes(id) : false
          }
      });
      let employeeLevelItems = Object.entries(view.employeeLevelMap).map(([id, label]) => {
          return {
              label: view.$t(`enum.employeeLevel.${id}`),
              value: id,
              selected: entity.details && entity.details.employeeLevels ? Object.values(entity.details.employeeLevels).includes(id) : false
          }
      });
      let employmentTypeItems = Object.entries(view.employmentTypeMap).map(([id, label]) => {
          return {
              label: view.$t(`enum.employmentType.${id}`),
              value: id,
              selected: entity.details && entity.details.employmentTypes ? Object.values(entity.details.employmentTypes).includes(id) : false
          }
      });

      const selectedCitizenShipIds = entity.details && entity.details.employeeCitizenShipIds
        ? JSON.parse(entity.details.employeeCitizenShipIds).map(Number)
        : [];
      const employeeCitizenShipItems = Object.values(view.countryEnumMap).map(country => ({
        label: view.$t(`enum.country.${country.id}`),
        value: country.id,
        selected: selectedCitizenShipIds.includes(Number(country.id)),
      })).sort((a, b) => a.label.localeCompare(b.label));

      // fields from enum
      let monthlyFinancialStatementFields = [];
      view.mdWagetypes.forEach(wageType => {
        monthlyFinancialStatementFields.push({value: wageType.id, label: view.$t(`wageTypes.md.${wageType.id}`)});
      });

      // TODO:
      // Diese Ids (value) werden in der Datenbank (individualwagetypedetails) als enumWageTypeId gespeichert.
      // Das Feld enumWageTypeId ist aber eine Referenz auf enum_wagetypes.id (liste von wagetypes vom monatsabschluss)
      // daher passen die ids nicht zusammen (zB:
      //    id 16 = paidWorkTimeOnlyPositive
      //    id 17 = holidayTime
      //    id 40 = paidWorkTimeOnlyPositive
      //    id 41 = paidWorkTimeOnlyNegative
      //    id 42 = paidOverTimeOnlyPositive
      //    id 43 = ???
      //    id 44 = ???
      //    id 45 = ???
      //    id 46 = ???
      //    id 47 = ???
      //    id 48 = ???
      //    id 49 = ???
      let customWageTypes = [];
        customWageTypes.push({
            value: 16,
            label: view.$t('settings.wage.paidVacationTimeAverage')
        }); // paidVacationTime
        customWageTypes.push({
            value: 17,
            label: view.$t('settings.wage.paidVacationTime')
        }); // paidVacationTime
        customWageTypes.push({
            value: 40,
            label: view.$t('settings.wage.workTimeMod25PlusOnly')
        }); // paidWorkTime
        customWageTypes.push({
            value: 41,
            label: view.$t('settings.wage.workTimeIstMinus169Plus25')
        }); // (IST - 169h) * 25%
        customWageTypes.push({
            value: 42,
            label: view.$t('settings.wage.workTimeIstMinusNazHourBonus')
        }); // (IST - NAZ) * Stundenbonus
        customWageTypes.push({
            value: 43,
            label: view.$t('settings.wage.socialEconomyOnCall')
        }); // SoWi Bereitschaftsdienst
        customWageTypes.push({
            value: 44,
            label: view.$t('settings.wage.socialEconomyNightWork')
        }); // SoWi Nachtarbeit
        customWageTypes.push({
            value: 45,
            label: view.$t('settings.wage.fullDaysAtPosition')
        }); // fullDaysAtSpot
        customWageTypes.push({
            value: 46,
            label: view.$t('settings.wage.monthlySalary')
        }); // monthlyPayment
        customWageTypes.push({
            value: 47,
            label: view.$t('settings.wage.dailyTotalWorkTime')
        }); // dailyTotalWorkTime
        customWageTypes.push({
            value: 48,
            label: view.$t('settings.wage.dailyOverTime')
        }); // dailyOverTime
        customWageTypes.push({
            value: 49,
            label: view.$t('settings.wage.dailyDiffTime')
        }); // dailyDiffTime
      customWageTypes.sort((a, b) => {
        if (a.label > b.label) {
          return 1;
        } else if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      let unavailabilityTypesList = JSON.parse(JSON.stringify(mdEmployeeAvailabilityTypes));
      let dynamicOvertimeUnavailabilityTypesList = JSON.parse(JSON.stringify(mdEmployeeAvailabilityTypes));
      if (entity.details && entity.details.dynamicOvertimeUnavailabilityTypes) {
        const selectedTypes = JSON.parse(entity.details.dynamicOvertimeUnavailabilityTypes).map(Number);  // Ensure values are treated as numbers
        dynamicOvertimeUnavailabilityTypesList.forEach(
          (at) => (at.selected = selectedTypes.includes(at.value))
        );
      }

      let isAbsenceType = entity.details && entity.details.workType === 1;
      let unavailabilityWithSubTypesSelected = entity.details && [2,4,6,8].includes(entity.details.unavailabilityType);
      let showUnavailabilitySubTypes = isAbsenceType && unavailabilityWithSubTypesSelected;
      if (entity.details && entity.details.employeeAvailabilitySubtypes && showUnavailabilitySubTypes) {
        const selectedTypes = JSON.parse(entity.details.employeeAvailabilitySubtypes).map(Number);  // Ensure values are treated as numbers
        mdEmployeeAvailabilitySubTypes.forEach((ast) => {
            ast.selected = selectedTypes.includes(ast.value);
          }
        );
      }

      if (entity.details && entity.details.enabledStores && entity.details.enabledStores != null) {
        const selectedStores = JSON.parse(entity.details.enabledStores).map(Number);  // Ensure values are treated as numbers
        mdStoresEnabled.forEach((es) => {
          es.selected = selectedStores.includes(es.value);
          }
        );
      }


      if (entity.details && entity.details.extraCostTypes) {
        const selectedTypes = JSON.parse(entity.details.extraCostTypes).map(Number);  // Ensure values are treated as numbers
        extraCostTypes.forEach(
          (ect) => (ect.selected = selectedTypes.includes(ect.value))  // Use includes on an array of numbers
        );
      }
      if (entity.details && entity.details.bonusExpenseTypes) {
        const selectedTypes = JSON.parse(entity.details.bonusExpenseTypes).map(Number);  // Ensure values are treated as numbers
        bonusExpenseTypes.forEach(
          (bet) => (bet.selected = selectedTypes.includes(bet.value))  // Use includes on an array of numbers
        );
      }

      if (entity.details) {
        entity.details.useHourlyWage = entity.details.useHourlyWage !== 0 && entity.details.useHourlyWage !== false;
        entity.details.useMaxWorkTime = entity.details.useMaxWorkTime !== 0 && entity.details.useMaxWorkTime !== false;
      }

      let timeFrom = entity.details ? view.$helpers.getMomentFromStringTZ(entity.details.timeFrom, "HH:mm") : this.$helpers.getMomentTZ().hours(0).minutes(0);
      let timeTo = entity.details ? view.$helpers.getMomentFromStringTZ(entity.details.timeTo, "HH:mm") : this.$helpers.getMomentTZ().hours(24).minutes(0);
      let checkFrom = entity.details && entity.details.checkFrom ? view.$helpers.getMomentFromStringTZ(entity.details.checkFrom, "HH:mm") : timeFrom.clone();
      let checkTo = entity.details && entity.details.checkTo ? view.$helpers.getMomentFromStringTZ(entity.details.checkTo, "HH:mm") : timeTo.clone();
      let enableCheckTime = entity.details && entity.details.workType === 0 && (entity.details.checkFrom != null || entity.details.checkTo != null) && (entity.details.minWorkTime > 0 || entity.details.maxWorkTime > 0) ? true : false;

      let showFilters = entity.details && (
        (entity.details.employeeIds && JSON.parse(entity.details.employeeIds).length > 0) ||
        (entity.details.collectiveContractIds && JSON.parse(entity.details.collectiveContractIds).length > 0) ||
        (entity.details.wageGroupIds && JSON.parse(entity.details.wageGroupIds).length > 0) ||
        (entity.details.spotIds && JSON.parse(entity.details.spotIds).length > 0) ||
        (entity.details.shiftUnitIds && JSON.parse(entity.details.shiftUnitIds).length > 0) ||
        (entity.details.shiftSpotIds && JSON.parse(entity.details.shiftSpotIds).length > 0) ||
        (entity.details.fromLocationIds && JSON.parse(entity.details.fromLocationIds).length > 0) ||
        (entity.details.contractTypes && JSON.parse(entity.details.contractTypes).length > 0) ||
        (entity.details.employeeCategories && JSON.parse(entity.details.employeeCategories).length > 0) ||
        (entity.details.employeeLevels && JSON.parse(entity.details.employeeLevels).length > 0) ||
        (entity.details.employmentTypes && JSON.parse(entity.details.employmentTypes).length > 0) ||
        (entity.details.allInTypes && JSON.parse(entity.details.allInTypes).length > 0) ||
        (entity.details.contractEnded && JSON.parse(entity.details.contractEnded).length > 0) ||
        (entity.details.employeeCitizenShipIds && JSON.parse(entity.details.employeeCitizenShipIds).length > 0) ||
        (!entity.details.applyToUnderage)
      );

      let dataEntries = [
        {
          label: "id",
          key: "id",
          hidden: true,
          value: entity.details ? entity.details.id : null,
        },
        {
          label: "wageTypeId",
          key: "wageTypeId",
          hidden: true,
          value: entity.id,
        },
        {
          // this will cause the workType dropdown to not open automatically
          label: "placeholder",
          key: "placeholder",
          hidden: false,
          styles: { 'opacity': '0', 'height': '0px' }
        },


        {
          label: view.$t('settings.wage.allLocations'),
          key: 'enabledAllStores',
          hidden: false,
          type: 'bool',
          value: entity.details != null ? entity.details.enabledStores == null : false, // if null or all stores are selected
        },
        {
          label: view.$t('settings.wage.locations'),
          key: "enabledStores",
          hidden: false,
          type: "dropdownsearch",
          styles: { width: "700px" },
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: mdStoresEnabled, // This is a map of all stores
            selectMultiple: true,
            selectedItems: [],
            selectedItem: null,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let enabledAllStores = datafill.entries.find((i) => i.key === "enabledAllStores");
            entryBeforeUpdate.hidden = enabledAllStores.value;
            //entryBeforeUpdate.dropdownSearchState.items = view.stores.map(store => ({value: store.id, selected: store.selected, label: `${store.name} (${store.city})`}));
            return entryBeforeUpdate;
          },
          value: entity.details && entity.details.enabledStores
            ? JSON.parse(entity.details.enabledStores)
            : null,
        },

        { divider: true },
        {
          label: view.$t('global.ui.type'),
          key: "workType",
          hidden: false,
          type: "dropdownsearch",
          styles: { width: "700px" },
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: workTypes,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: entity.details
              ? workTypes.find((wt) => wt.value === entity.details.workType)
              : null,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          value: entity.details && workTypes.find((wt) => wt.value === entity.details.workType)
            ? workTypes.find((wt) => wt.value === entity.details.workType).value
            : null,
        },
        {
          label: view.$t('settings.wage.absenceType'),
          key: "unavailabilityType",
          hidden: entity.details ? !(entity.details.workType === 1) : false,
          value: entity.details ? entity.details.unavailabilityType : null,
          type: "dropdownsearch",
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: unavailabilityTypesList,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: entity.details ? unavailabilityTypesList.find(ut => ut.value === entity.details.unavailabilityType) : null,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let unavailability =
              datafill.entries.find((i) => i.key === "workType").value === 1;

            entryBeforeUpdate.hidden = !unavailability;
            return entryBeforeUpdate;
          },
        },

        {
          label: view.$t('settings.wage.detail'),
          key: "unavailabilitySubTypes",
          // Default to hidden, will be shown based on computed logic below --> cant do it like this, because it will not show if we open
          // a popup, which is preselected with Abwesenheit Krankheit
          hidden: !showUnavailabilitySubTypes,
          type: "dropdownsearch",
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: entity.details ? mdEmployeeAvailabilitySubTypes.filter(
              (ast) => ast.parentType === entity.details.unavailabilityType
            ) : mdEmployeeAvailabilitySubTypes,
            selectMultiple: true,
            selectedItems: [],
            selectedItem: null,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            // Determine if the current workType is 'Abwesenheiten'
            let isAbsenceType = datafill.entries.find((i) => i.key === "workType").value === 1;

            // Determine if 'Krankheit', 'Sonstiges' or 'Lohnfortzahlung' is selected in unavailabilityTypes
            let unavailabilityWithSubTypesSelected = [2,4,6,8].includes(datafill.entries.find((i) => i.key === "unavailabilityType").value);

            // Show this block if workType is 'Abwesenheiten' and 'Krankheit' is selected
            let showUnavailabilitySubTypes = isAbsenceType && unavailabilityWithSubTypesSelected;
            entryBeforeUpdate.hidden = !showUnavailabilitySubTypes;

            // set items based on parentType
            entryBeforeUpdate.dropdownSearchState.items = mdEmployeeAvailabilitySubTypes.filter(
              (ast) => ast.parentType === datafill.entries.find((i) => i.key === "unavailabilityType").value
            );

            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.absenceCode'),
          key: "unavailabilityCode",
          hidden: entity.details ? !(entity.details.workType === 1) : true,
          value: entity.details ? entity.details.unavailabilityCode : null,
          type: "text",
          length: 20,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let unavailability = datafill.entries.find((i) => i.key === "workType").value === 1;
            entryBeforeUpdate.hidden = !unavailability;
            return entryBeforeUpdate;
          },
        },
        {
          divider: true,
          hidden: entity.details ? !(entity.details.workType === 1) : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            entryBeforeUpdate.hidden = !(worktype === 1);
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.absenceOnNonWorkdaysInclude'),
          key: 'includeAllDays',
          hidden: entity.details ? !(entity.details.workType === 1) : true,
          type: 'bool',
          value: entity.details != null ? entity.details.includeAllDays : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            entryBeforeUpdate.hidden = !(worktype === 1);
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.countsAlwaysAsWorkday'),
          key: 'alwaysWork',
          hidden: entity.details ? !(entity.details.workType === 1 && entity.details.includeAllDays) : true,
          type: 'bool',
          value: entity.details != null ? entity.details.alwaysWork : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let includeAllDays = datafill.entries.find((i) => i.key === "includeAllDays").value;
            let hidden = !(worktype === 1 && includeAllDays);
            entryBeforeUpdate.hidden = hidden;
            entryBeforeUpdate.value = hidden ? false : entryBeforeUpdate.value; // if the field is hidden, set it to false
            return entryBeforeUpdate;
          },
        },
        {
          divider: true,
          hidden: entity.details ? !(entity.details.workType === 1) : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            entryBeforeUpdate.hidden = !(worktype === 1);
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.applyAverageHours'),
          key: 'useAverages',
          hidden: false,
          type: 'bool',
          value: entity.details != null ? entity.details.useAverageValues : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            entryBeforeUpdate.hidden = !(worktype === 1);
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.applyAverageWage'),
          key: 'useAverageWage',
          hidden: false,
          type: 'bool',
          value: entity.details != null ? entity.details.useAverageWage : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let useAverages = datafill.entries.find((i) => i.key === "useAverages");
            entryBeforeUpdate.hidden = !useAverages.value;
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.overrideFactorZero'),
          key: 'overwritePaymentWithZero',
          hidden: false,
          type: 'bool',
          value: entity.details != null ? entity.details.overwritePaymentWithZero : false,
        },
        { divider: true },
        {
          label: view.$t('settings.wage.includeInHourAndDayTotals'),
          key: 'includeInSum',
          hidden: false,
          type: 'bool',
          value: entity.details != null ? entity.details.includeInSum : true, // default true
        },
        {
          label: view.$t('settings.wage.validFrom'),
          key: 'validFrom',
          required: false,
          showDateField: entity.details != null ? entity.details.validFrom != null : false,
          hidden: false,
          type: 'date',
          value: entity.details != null && entity.details.validFrom != null ? this.$helpers.getMomentFromStringUTC(entity.details.validFrom, 'YYYY-MM-DD HH:mm').local() : this.$helpers.getMoment().startOf('day'),
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype0 = datafill.entries.find((i) => i.key === "workType").value === 0;
            entryBeforeUpdate.hidden = !worktype0;
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.validTo'),
          key: 'validTo',
          required: false,
          showDateField: entity.details != null ? entity.details.validTo != null : false,
          hidden: false,
          type: 'date',
          value: entity.details != null && entity.details.validTo != null ? this.$helpers.getMomentFromStringUTC(entity.details.validTo, 'YYYY-MM-DD HH:mm').local() : this.$helpers.getMoment().endOf('day'),
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype0 = datafill.entries.find((i) => i.key === "workType").value === 0;
            entryBeforeUpdate.hidden = !worktype0;
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.repeatYearly'),
          key: 'repeatYearly',
          hidden: entity.details != null ? entity.details.validFrom == null || entity.details.validTo == null : true,
          type: 'bool',
          value: entity.details != null ? entity.details.repeatYearly : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype0 = datafill.entries.find((i) => i.key === "workType").value === 0;
            let validFrom = datafill.entries.find((i) => i.key === "validFrom").showDateField;
            let validTo = datafill.entries.find((i) => i.key === "validTo").showDateField;
            if(!worktype0 || !validFrom || !validTo){
              entryBeforeUpdate.hidden = true;
              entryBeforeUpdate.value = false;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },

        { divider: true },
        {label: view.$t('settings.wage.wageTypeMonthlyTotals'), key: 'enumWageTypeId',
          hidden: entity.details ? !(entity.details.workType === 4) : true, type: 'dropdownsearch',
          value: entity.details && entity.details.enumWageTypeId && customWageTypes.find(f => { return f.value === entity.details.enumWageTypeId})
            ? customWageTypes.find(f => { return f.value === entity.details.enumWageTypeId}).value : null,
          dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: customWageTypes,
            selectMultiple: false,
            selectedItem: entity.details && entity.details.enumWageTypeId != null ?
              customWageTypes.find(f => { return f.value === entity.details.enumWageTypeId}) : null,
            selectFirst: false,
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 4)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {
          label: view.$t('settings.wage.weekdays'),
          key: "weekDays",
          hidden: entity.details ? !(entity.details.workType === 0 || entity.details.workType === 1 || (entity.details.workType === 4 && entity.details.enumWageTypeId === 48)) : false,
          flexGroup: false,
          type: "togglelist",
          toggleEntries: [
            {
              label: view.$t('global.time.mo'),
              value: 1,
              selected: entity.details ? entity.details.weekDays.includes(1) : true,
            },
            {
              label: view.$t('global.time.tu'),
              value: 2,
              selected: entity.details ? entity.details.weekDays.includes(2) : true,
            },
            {
              label: view.$t('global.time.we'),
              value: 3,
              selected: entity.details ? entity.details.weekDays.includes(3) : true,
            },
            {
              label: view.$t('global.time.th'),
              value: 4,
              selected: entity.details ? entity.details.weekDays.includes(4) : true,
            },
            {
              label: view.$t('global.time.fr'),
              value: 5,
              selected: entity.details ? entity.details.weekDays.includes(5) : true,
            },
            {
              label: view.$t('global.time.sa'),
              value: 6,
              selected: entity.details ? entity.details.weekDays.includes(6) : true,
            },
            {
              label: view.$t('global.time.su'),
              value: 7,
              selected: entity.details ? entity.details.weekDays.includes(7) : true,
            },
          ],
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            entryBeforeUpdate.hidden = !(worktype === 0 || worktype === 1 || (worktype === 4 && enumWageTypeId === 48));
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.holidayMode'),
          key: "holidays",
          hidden: entity.details ? !(entity.details.workType === 0 || entity.details.workType === 1 || (entity.details.workType === 4 && entity.details.enumWageTypeId === 48)) : false,
          type: 'dropdownsearch',
          value: entity.details ? entity.details.holidays : 0,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: holidayModes,
            selectMultiple: false,
            selectedItem: entity.details ? holidayModes.find(hm => hm.value === entity.details.holidays) : holidayModes.find(hm => hm.value === 0),
            selectFirst: false,
            styleLight: true,
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            entryBeforeUpdate.hidden = !(worktype === 0 || worktype === 1 || (worktype === 4 && enumWageTypeId === 48));
            return entryBeforeUpdate;
          },
        },
        {label: view.$t('settings.wage.holidayType'), key: 'holidayTypes',
          hidden: entity.details ? !((entity.details.workType == 0 || entity.details.workType == 1 || (entity.details.workType === 4 && entity.details.enumWageTypeId === 48)) && entity.details.holidays != 0) : false,
          type: 'dropdownsearch',
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: holidayTypes,
            selectMultiple: true,
            selectedItem: null,
            selectFirst: false,
            styleLight: true,
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let holidays = datafill.entries.find((i) => i.key === "holidays").value;
            if(!((worktype == 0 || worktype == 1 || (worktype === 4 && datafill.entries.find((i) => i.key === "enumWageTypeId").value === 48)) && holidays != 0)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.timeFrom'),
          key: "timeFrom",
          hidden: entity.details ? !(entity.details.workType === 0 || entity.details.workType === 1 || (entity.details.workType === 4 && entity.details.enumWageTypeId === 48)) : false,
          type: "timeframe",
          value: timeFrom,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            entryBeforeUpdate.hidden = !(worktype === 0 || worktype === 1 || (worktype === 4 && enumWageTypeId === 48));
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.timeTo'),
          key: "timeTo",
          hidden: entity.details ? !(entity.details.workType === 0 || entity.details.workType === 1 || (entity.details.workType === 4 && entity.details.enumWageTypeId === 48)) : false,
          type: "timeframe",
          value: timeTo,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            entryBeforeUpdate.hidden = !(worktype === 0 || worktype === 1 || (worktype === 4 && enumWageTypeId === 48));
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.shiftStartsWithinRange'),
          key: 'startsWithin',
          hidden: entity.details ? entity.details.workType != 0 : true,
          type: 'bool',
          value: entity.details != null && entity.details.startsWithin != null ? entity.details.startsWithin : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
            if(workType0){
                entryBeforeUpdate.hidden = false;
            } else {
                entryBeforeUpdate.hidden = true;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.excludeBreakTime'), key: 'excludeBreaksFromWorkTime',
            hidden: entity.details ? !(entity.details.workType === 0) : true,
            type: 'bool',
            value: entity.details != null ? entity.details.excludeBreaksFromWorkTime : true,
              computed: (datafill, lastVal, entryBeforeUpdate) => {
                  let worktype = datafill.entries.find((i) => i.key === "workType").value;
                  let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;

                  if(worktype === 0 || (worktype === 4 && (enumWageTypeId === 47 || enumWageTypeId === 48 || enumWageTypeId === 49))){
                      entryBeforeUpdate.hidden = false;
                  } else {
                      entryBeforeUpdate.hidden = true;
                      entryBeforeUpdate.value = true;
                  }
                  return entryBeforeUpdate;
              }
        },
        {
          divider: true,
          hidden: entity.details ? !(entity.details.workType === 0 || entity.details.workType === 1) : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            entryBeforeUpdate.hidden = !(worktype === 0 || worktype === 1);
            return entryBeforeUpdate;
          },
        },
        {label: view.$t('settings.wage.applyToWorkDaysOnly'), key: 'applyToWorkDaysOnly',
            hidden: true,
            disabled: true, // do not let this field be changed, it is only for display purposes
            type: 'bool',
            value: true,
              computed: (datafill, lastVal, entryBeforeUpdate) => {
                  let worktype = datafill.entries.find((i) => i.key === "workType").value;
                  let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;

                  if(worktype === 4 && enumWageTypeId === 49){
                      entryBeforeUpdate.hidden = false;
                  } else {
                      entryBeforeUpdate.hidden = true;
                  }
                  return entryBeforeUpdate;
              }
        },
        {label: view.$t('settings.wage.minWorkTime'), key: 'minWorkTime', hidden: false, type: 'slider', value: entity.details != null ? entity.details.minWorkTime : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 24*60, value: entity.details != null ? entity.details.minWorkTime : 0, step: 15, DisplayLabel: (val) => {

              return (val/60).toFixed(2)+"h";
            }, inputControl: true, sliderInput: (x) => { return x * 60}},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            entryBeforeUpdate.hidden = !(worktype === 0 || worktype === 1) && !(worktype === 4 && (enumWageTypeId === 47 || enumWageTypeId === 48 || enumWageTypeId === 49));
            if (worktype === 4 && enumWageTypeId === 48) {
              entryBeforeUpdate.label = view.$t('settings.wage.overtimeFrom');
            } else if (worktype === 4 && enumWageTypeId === 49) {
              entryBeforeUpdate.label = view.$t('settings.wage.diffTime');
            } else {
              entryBeforeUpdate.label = view.$t('settings.wage.minWorkTime');
            }
            return entryBeforeUpdate;
          },},
        {label: view.$t('settings.wage.applyMaxWorkTime'), key: 'useMaxWorkTime', hidden: false, type: 'bool', value: entity.details != null ? entity.details.useMaxWorkTime : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            entryBeforeUpdate.hidden = !(worktype === 0 || worktype === 1) && !(worktype === 4 && enumWageTypeId === 48);
            if (entryBeforeUpdate.hidden) {
              entryBeforeUpdate.value = false;
            }
            if (enumWageTypeId === 48) {
              entryBeforeUpdate.label = view.$t('settings.wage.applyOvertimeTo');
            } else {
              entryBeforeUpdate.label = view.$t('settings.wage.applyMaxWorkTime');
            }
            return entryBeforeUpdate;
          },},
        {label: view.$t('settings.wage.maxWorkTime'), key: 'maxWorkTime', hidden: entity.details != null ? !entity.details.useMaxWorkTime : true, type: 'slider', value: entity.details != null ? (entity.details.maxWorkTime != null ?  entity.details.maxWorkTime : 0): 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 24 *60, value: entity.details != null ? (entity.details.maxWorkTime != null ?  entity.details.maxWorkTime : 0) : 0, step: 15, DisplayLabel: (val) => {

              return (val/60).toFixed(2)+"h";
            }, inputControl: true, sliderInput: (x) => { return x * 60}},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let useMaxWorkTime = datafill.entries.find((i) => i.key == "useMaxWorkTime").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;

            if (useMaxWorkTime) {
              entryBeforeUpdate.hidden = false;
            } else {
              entryBeforeUpdate.slider.value = 0;
              entryBeforeUpdate.value = 0;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;
            }
            if (enumWageTypeId === 48) {
              entryBeforeUpdate.label = view.$t('settings.wage.overtimeTo');
            } else {
              entryBeforeUpdate.label = view.$t('settings.wage.maxWorkTime');
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.excludeCheckBreakTime'), key: 'excludeCheckBreaksFromWorkTime',
            hidden: entity.details ? !(entity.details.workType === 0 && (entity.details.maxWorkTime > 0 || entity.details.minWorkTime > 0)) : true,
            type: 'bool',
            value: entity.details != null ? entity.details.excludeCheckBreaksFromWorkTime : false,
              computed: (datafill, lastVal, entryBeforeUpdate) => {
                  let worktype = datafill.entries.find((i) => i.key === "workType").value;
                  let minWorkTime = datafill.entries.find(i => i.key == 'minWorkTime').value;
                  let maxWorkTime = datafill.entries.find(i => i.key == 'maxWorkTime').value;

                  if(worktype === 0 && (minWorkTime > 0 || maxWorkTime > 0)){
                      entryBeforeUpdate.hidden = false;
                  } else {
                      entryBeforeUpdate.hidden = true;
                      entryBeforeUpdate.value = false;
                  }
                  return entryBeforeUpdate;
              }
        },
        {label: view.$t('settings.wage.applyCheckInterval'), key: 'useCheckTime',
          hidden: entity.details ? !(entity.details.workType === 0 && (entity.details.maxWorkTime > 0 || entity.details.minWorkTime > 0)) : true,
          type: 'bool',
          value: enableCheckTime,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
                let worktype = datafill.entries.find((i) => i.key === "workType").value;
                let minWorkTime = datafill.entries.find(i => i.key == 'minWorkTime').value;
                let maxWorkTime = datafill.entries.find(i => i.key == 'maxWorkTime').value;

                if(worktype === 0 && (minWorkTime > 0 || maxWorkTime > 0)){
                    entryBeforeUpdate.hidden = false;

                } else {
                    entryBeforeUpdate.hidden = true;
                    entryBeforeUpdate.value = false;
                }
                return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.checkFrom'), key: 'checkFrom', hidden: !enableCheckTime, flexGroup: false, type: 'timeframe', value: checkFrom, timeBig: false,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
                let useCheckTime = datafill.entries.find(i => i.key == 'useCheckTime').value;

                if(useCheckTime){
                    entryBeforeUpdate.hidden = false;
                } else {
                    entryBeforeUpdate.hidden = true;
                }
                return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.checkTo'), key: 'checkTo', hidden: !enableCheckTime, flexGroup: false, type: 'timeframe', value: checkTo, timeBig: false,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
                let useCheckTime = datafill.entries.find(i => i.key == 'useCheckTime').value;

                if(useCheckTime){
                    entryBeforeUpdate.hidden = false;
                } else {
                    entryBeforeUpdate.hidden = true;
                }
                return entryBeforeUpdate;
            }
        },
        {divider: true,
          hidden: entity.details ? !(entity.details.workType === 0 || entity.details.workType === 1) || (entity.details.workType === 1 && entity.details.useAverages) : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let useAverages = datafill.entries.find((i) => i.key === "useAverages");
            entryBeforeUpdate.hidden = !(worktype === 0 || worktype === 1) || (worktype === 1 && useAverages.value);
            return entryBeforeUpdate;
          },
        },
        {label: view.$t('settings.wage.applyBonus'), key: 'useBonus',
          hidden: entity.details ? !(entity.details.workType === 0 || entity.details.workType === 1): false,
          type: 'dropdownsearch', value: entity.details ? entity.details.useBonus : bonusTypes[0].value,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: bonusTypes,
            selectMultiple: false,
            selectedItem: entity.details ? bonusTypes.find(bt => bt.value === entity.details.useBonus) : bonusTypes[0],
            selectFirst: false,
            styleLight: true,
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let useAverages = datafill.entries.find((i) => i.key === "useAverages");
            if(!(worktype === 0 || worktype === 1)  || (worktype === 1 && useAverages.value)){
              entryBeforeUpdate.hidden = true;
              entryBeforeUpdate.value = 0;
              entryBeforeUpdate.dropdownSearchState.selectedItem = bonusTypes[0];
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          },
        },
        {label: view.$t('settings.wage.calculationMode'), key: 'bonusMode',
          hidden: entity.details ? (entity.details.useBonus === 0) : true, type: 'dropdownsearch',
          value: entity.details && entity.details.bonusMode ? entity.details.bonusMode : 3, dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: bonusModeItemsFiltered,
            selectMultiple: false,
            selectedItem: entity.details && entity.details.bonusMode ? bonusModeItemsFiltered.find(bm => bm.value === entity.details.bonusMode) : bonusModeItemsFiltered.find(bm => bm.value === 3),
            selectFirst: false,
            styleLight: true,
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype0 = datafill.entries.find((i) => i.key === "workType").value == 0;
            let worktype1 = datafill.entries.find((i) => i.key === "workType").value == 1;
            let hiddenWorkTypes = !(worktype0 || worktype1);
            if(hiddenWorkTypes || bonus == 0){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
              if (worktype0) {
                entryBeforeUpdate.dropdownSearchState.items = bonusModeItems.map(bm => ({value: bm.value, label: bm.label, alwaysShow: bm.alwaysShow}));
              } else {
                entryBeforeUpdate.dropdownSearchState.items = bonusModeItems.filter(bm => bm.alwaysShow).map(bm => ({value: bm.value, label: bm.label, alwaysShow: bm.alwaysShow}));
                let foundItem = entryBeforeUpdate.dropdownSearchState.items.find(bm => bm.value === entryBeforeUpdate.value);
                if (!foundItem) {
                  entryBeforeUpdate.value = 3;
                }
              }
              entryBeforeUpdate.dropdownSearchState.selectedItem = entryBeforeUpdate.dropdownSearchState.items.find(bm => bm.value === entryBeforeUpdate.value);
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.applyHourlyWage'), key: 'useHourlyWage',
          hidden: entity.details ? (entity.details.useBonus === 0 || !(entity.details.bonusMode === 1 || entity.details.bonusMode === 3 || entity.details.bonusMode === 5)) : true,
          type: 'bool', value: entity.details != null ? entity.details.useHourlyWage : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let hiddenWorkTypes = !(worktype === 0 || worktype === 1);
            if(hiddenWorkTypes || bonus == 0 || !(mode == 1 || mode == 3 || mode == 5)){
              entryBeforeUpdate.hidden = true;
              entryBeforeUpdate.value = false;
            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          } },
        {label: view.$t('settings.wage.hourlyWageBonus'), key: 'hourlyWagePercentage',
          hidden: entity.details ? (entity.details.useBonus === 0 || (!entity.details.useHourlyWage || !(entity.details.bonusMode === 1 || entity.details.bonusMode === 3 || entity.details.bonusMode === 5))) : true,
          type: 'slider', value: entity.details != null ? entity.details.hourlyWagePercentage : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 400, value: entity.details != null ? entity.details.hourlyWagePercentage : 0, step: 0.01, DisplayLabel: (val) => {

              return val+"%";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let useHourlyWage = datafill.entries.find(i => i.key == 'useHourlyWage').value;
            let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let hiddenWorkTypes = !(worktype === 0 || worktype === 1);
            if(!hiddenWorkTypes && bonus !== 0 && mode == 7){
              entryBeforeUpdate.label = view.$t('settings.wage.hourlyWageAdditionalBonus');
              entryBeforeUpdate.hidden = false;

            } else if(hiddenWorkTypes || bonus == 0 || !useHourlyWage || !(mode == 1 || mode == 3 || mode == 5)){

              entryBeforeUpdate.slider.value = entity.details != null ? entity.details.hourlyWagePercentage : 0;
              entryBeforeUpdate.value = entity.details != null ? entity.details.hourlyWagePercentage : 0;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;
              entryBeforeUpdate.label = view.$t('settings.wage.hourlyWageBonus');

            } else {
              entryBeforeUpdate.label = view.$t('settings.wage.hourlyWageBonus');
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.hourBonus'), key: 'bonusHour',
          hidden: entity.details ? (entity.details.useBonus === 0 || (entity.details.useHourlyWage || !(entity.details.bonusMode === 1 || entity.details.bonusMode === 3 || entity.details.bonusMode === 5))) : true,
          type: 'slider', value: entity.details != null ? entity.details.bonusHour : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 100*100, value: entity.details != null ? entity.details.bonusHour : 0, step: 1, DisplayLabel: (val) => {

              return (val/100.0).toFixed(2)+"€";
            }, inputControl: true, sliderInput: (x) => { return x * 100}},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let useHourlyWage = datafill.entries.find(i => i.key == 'useHourlyWage').value;
            let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let hiddenWorkTypes = !(worktype === 0 || worktype === 1);
            if(hiddenWorkTypes || bonus == 0 || useHourlyWage || !(mode == 1 || mode == 3 || mode == 5)){

              entryBeforeUpdate.slider.value = entity.details != null ? entity.details.bonusHour : 0;
              entryBeforeUpdate.value = entity.details != null ? entity.details.bonusHour : 0;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;

            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.applyTariffGroup'), key: 'useWageGroup',
          hidden: entity.details ? (entity.details.useBonus === 0 || !(entity.details.bonusMode === 6)) : true,
          type: 'bool', value: entity.details != null ? entity.details.useWageGroup : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let hiddenWorkTypes = !(worktype === 0 || worktype === 1);
            if(hiddenWorkTypes || bonus == 0 || !(mode == 6)){
              entryBeforeUpdate.hidden = true;
              entryBeforeUpdate.value = false;
            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          } },
        {label: view.$t('settings.wage.tariffGroup'), key: 'wageGroupId',
          hidden: entity.details ? (entity.details.useBonus === 0 || (!entity.details.useWageGroup || !(entity.details.bonusMode === 6))) : true,
          type: 'dropdownsearch', value: entity.details ? entity.details.wageGroupId : null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: wgBonusItems,
                selectMultiple: false,
                selectedItem: entity.details && entity.details.wageGroupId ? wgBonusItems.find(i => i.value === entity.details.wageGroupId) : null,
                selectFirst: false,
                styleLight: true
            },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let useWageGroup = datafill.entries.find(i => i.key == 'useWageGroup').value;
            let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let hiddenWorkTypes = !(worktype === 0 || worktype === 1);
            if(hiddenWorkTypes || bonus == 0 || !useWageGroup || !(mode == 6)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.hourlyWage'), key: 'hourlyWage',
          hidden: entity.details ? (entity.details.useBonus === 0 || (entity.details.useWageGroup || !(entity.details.bonusMode === 6))) : true,
          type: 'slider', value: entity.details && entity.details.hourlyWage ? entity.details.hourlyWage : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 100*100, value: entity.details && entity.details.hourlyWage ? entity.details.hourlyWage : 0, step: 1, DisplayLabel: (val) => {

              return (val/100.0).toFixed(2)+"€";
            }, inputControl: true, sliderInput: (x) => { return x * 100}},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let useWageGroup = datafill.entries.find(i => i.key == 'useWageGroup').value;
            let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let hiddenWorkTypes = !(worktype === 0 || worktype === 1);
            if(hiddenWorkTypes || bonus == 0 || useWageGroup || !(mode == 6)){

              entryBeforeUpdate.slider.value = entity.details && entity.details.hourlyWage ? entity.details.hourlyWage : 0;
              entryBeforeUpdate.value = entity.details && entity.details.hourlyWage ? entity.details.hourlyWage : 0;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;

            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.flatBonus'), key: 'bonusShift',
          hidden: entity.details ? (entity.details.useBonus === 0 || !(entity.details.bonusMode === 1 || entity.details.bonusMode === 2 || entity.details.bonusMode === 4)) : true,
          type: 'slider', value: entity.details != null ? entity.details.bonusShift : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 100*100, value: entity.details != null ? entity.details.bonusShift : 0, step: 1, DisplayLabel: (val) => {

              return (val/100.0).toFixed(2)+"€";
            }, inputControl: true, sliderInput: (x) => { return x * 100}},
          computed: (datafill, lastVal, entryBeforeUpdate) => {

            let mode = datafill.entries.find(i => i.key == 'bonusMode').value;
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let hiddenWorkTypes = !(worktype === 0 || worktype === 1);
            if(hiddenWorkTypes || bonus == 0 || !(mode == 1 || mode == 2 || mode == 4)){

              entryBeforeUpdate.slider.value = entity.details != null ? entity.details.bonusShift : 0;
              entryBeforeUpdate.value = entity.details != null ? entity.details.bonusShift : 0;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;

            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.flatLimit'), key: 'bonusCutoff',
          hidden: entity.details ? (entity.details.useBonus === 0 || !(entity.details.bonusMode === 1 || entity.details.bonusMode === 4 || entity.details.bonusMode === 5)) : true,
          type: 'slider', value: entity.details != null ? entity.details.bonusCutoff : 50,
          slider: {hideMin: true, hideMax: true, min: 0, max: 100, value: entity.details != null ? entity.details.bonusCutoff : 50, step: 1, DisplayLabel: (val) => {

              return val+"%";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let bonusMode = datafill.entries.find(i => i.key == 'bonusMode').value;
            let bonus = datafill.entries.find(i => i.key == 'useBonus').value;
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let hiddenWorkTypes = !(worktype === 0 || worktype === 1);
            if(hiddenWorkTypes || bonus == 0 || !(bonusMode === 1 || bonusMode === 4 || bonusMode === 5)){

              entryBeforeUpdate.slider.value = 50;
              entryBeforeUpdate.value = 50;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;

            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },



        {
          label: view.$t('settings.wage.positiveSign'),
          key: 'invertSignWorktype2',
          hidden: entity.details ? !(entity.details.workType === 2) : true,
          type: 'bool',
          value: entity.details != null ? entity.details.invertSign : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 2)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {
          label: view.$t('settings.wage.negativeSign'),
          key: 'invertSignWorktype3',
          hidden: entity.details ? !(entity.details.workType === 3) : true,
          type: 'bool',
          value: entity.details != null ? entity.details.invertSign : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 3)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },



        {label: view.$t('settings.wage.otherCostType'), key: 'extraCostTypes',
          hidden: entity.details ? !(entity.details.workType === 2) : true,
          type: 'dropdownsearch',
          value: entity.details ? (entity.details.extraCostTypes ? JSON.parse(entity.details.extraCostTypes) : []) : extraCostTypes[0].value,
          dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: extraCostTypes.sort((a,b) => a.label.localeCompare(b.label)),
            selectMultiple: true,
            selectedItem: null,
            selectFirst: false,
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 2)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.otherCostPayment'), key: 'extraCostPercentage',
          hidden: entity.details ? !(entity.details.workType === 2) : true,
          type: 'slider', value: entity.details && entity.details.extraCostPercentage ? entity.details.extraCostPercentage : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 400, value: entity.details && entity.details.extraCostPercentage ? entity.details.extraCostPercentage : 0, step: 1, DisplayLabel: (val) => {

              return val+"%";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 2)){

              entryBeforeUpdate.slider.value = entity.details && entity.details.extraCostPercentage ? entity.details.extraCostPercentage : 0;
              entryBeforeUpdate.value = entity.details && entity.details.extraCostPercentage ? entity.details.extraCostPercentage : 0;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;

            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.bonusPaymentType'), key: 'bonusExpenseTypes',
          hidden: entity.details ? !(entity.details.workType === 3) : true, type: 'dropdownsearch',
          value: entity.details ? entity.details.bonusExpenseTypes : bonusExpenseTypes[0].value, dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: bonusExpenseTypes.sort((a,b) => a.label.localeCompare(b.label)),
            selectMultiple: true,
            selectedItem: null,
            selectFirst: false,
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 3)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.bonusPaymentPayment'), key: 'bonusPaymentPercentage',
          hidden: entity.details ? !(entity.details.workType === 3) : true,
          type: 'slider', value: entity.details && entity.details.bonusPaymentPercentage ? entity.details.bonusPaymentPercentage : 100,
          slider: {hideMin: true, hideMax: true, min: 0, max: 400, value: entity.details && entity.details.bonusPaymentPercentage ? entity.details.bonusPaymentPercentage : 100, step: 0.01, DisplayLabel: (val) => {

              return val+"%";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 3)){

              entryBeforeUpdate.slider.value = entity.details && entity.details.bonusPaymentPercentage ? entity.details.bonusPaymentPercentage : 100;
              entryBeforeUpdate.value = entity.details && entity.details.bonusPaymentPercentage ? entity.details.bonusPaymentPercentage : 100;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;

            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.wageTypeMonthlyClosing'), key: 'mdWageTypeId',
          hidden: entity.details ? !(entity.details.workType === 5) : true, type: 'dropdownsearch',
          value: entity.details && entity.details.mdWageTypeId && monthlyFinancialStatementFields.find(f => { return f.value === entity.details.mdWageTypeId})
            ? monthlyFinancialStatementFields.find(f => { return f.value === entity.details.mdWageTypeId}).value : null,
          dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: monthlyFinancialStatementFields.sort((a,b) => a.label.localeCompare(b.label)),
            selectMultiple: false,
            selectedItem: entity.details && entity.details.mdWageTypeId != null ?
            monthlyFinancialStatementFields.find(f => { return f.value === entity.details.mdWageTypeId}) : null,
            selectFirst: false,
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 5)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.modifyHours'), key: 'mdWageTypeHourModBool',
          hidden: entity.details ? !([4, 5].includes(entity.details.workType)) : true,
          type: 'bool',
          value: entity.details && entity.details.mdWageTypeHourModBool ? entity.details.mdWageTypeHourModBool : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!([4, 5].includes(worktype))){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.typeOfModification'), key: 'mdWageTypeHourModType',
          hidden: entity.details ? !([4, 5].includes(entity.details.workType) && entity.details.mdWageTypeHourModBool) : true,
          type: 'dropdownsearch', value: entity.details && entity.details.mdWageTypeHourModType && mdWageTypeHourModTypes.find(f => { return f.value === entity.details.mdWageTypeHourModType})
            ? mdWageTypeHourModTypes.find(f => { return f.value === entity.details.mdWageTypeHourModType}).value : null,
          dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: mdWageTypeHourModTypes,
            selectMultiple: false,
            selectedItem: entity.details && entity.details.mdWageTypeHourModType != null ?
              mdWageTypeHourModTypes.find(f => { return f.value === entity.details.mdWageTypeHourModType}) :
              mdWageTypeHourModTypes.find(f => { return f.value === 1}),
            selectFirst: false,
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let mdWageTypeHourModBool = datafill.entries.find((i) => i.key === "mdWageTypeHourModBool").value;
            if(!([4, 5].includes(worktype))){
              entryBeforeUpdate.hidden = true;
            } else if (!mdWageTypeHourModBool) {
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        // mdWageTypeHourModType (mdWageTypeHourModTypes: mdWageTypeHourModPercentage (1), mdWageTypeHourModSurcharge (2), mdWageTypeHourModReduction (3), mdWageTypeHourModMaximum (4), mdWageTypeHourModMinimum (5))
        {label: view.$t('settings.wage.percent'), key: 'mdWageTypeHourModPercentage',
          hidden: entity.details ? !([4, 5].includes(entity.details.workType) && entity.details.mdWageTypeHourModBool && (entity.details.mdWageTypeHourModType === 1 || entity.details.mdWageTypeHourModType == null)) : true,
          type: 'slider',
          value: entity.details && entity.details.mdWageTypeHourModPercentage ? entity.details.mdWageTypeHourModPercentage : 100,
          slider: {hideMin: true, hideMax: true, min: 0, max: 400, value: entity.details && entity.details.mdWageTypeHourModPercentage ? entity.details.mdWageTypeHourModPercentage : 100, step: 1, DisplayLabel: (val) => {
              return val+"%";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let mdWageTypeHourModBool = datafill.entries.find((i) => i.key === "mdWageTypeHourModBool").value;
            let mdWageTypeHourModType = datafill.entries.find((i) => i.key === "mdWageTypeHourModType").value;
            if(!([4, 5].includes(worktype))){
              entryBeforeUpdate.hidden = true;
            } else if (!mdWageTypeHourModBool || !(mdWageTypeHourModType === 1 || mdWageTypeHourModType == null)) {
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.surcharge'), key: 'mdWageTypeHourModSurcharge',
          hidden: entity.details ? !([4, 5].includes(entity.details.workType) && entity.details.mdWageTypeHourModBool && entity.details.mdWageTypeHourModType === 2) : true,
          type: 'slider',
          value: entity.details && entity.details.mdWageTypeHourModSurcharge ? entity.details.mdWageTypeHourModSurcharge : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 100, value: entity.details && entity.details.mdWageTypeHourModSurcharge ? entity.details.mdWageTypeHourModSurcharge : 0, step: 0.25, DisplayLabel: (val) => {
              return val+"";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let mdWageTypeHourModBool = datafill.entries.find((i) => i.key === "mdWageTypeHourModBool").value;
            let mdWageTypeHourModType = datafill.entries.find((i) => i.key === "mdWageTypeHourModType").value;
            if(!([4, 5].includes(worktype))){
              entryBeforeUpdate.hidden = true;
            } else if (!mdWageTypeHourModBool || !(mdWageTypeHourModType === 2)) {
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.reduction'), key: 'mdWageTypeHourModReduction',
          hidden: entity.details ? !([4, 5].includes(entity.details.workType) && entity.details.mdWageTypeHourModBool && entity.details.mdWageTypeHourModType === 3) : true,
          type: 'slider',
          value: entity.details && entity.details.mdWageTypeHourModReduction ? entity.details.mdWageTypeHourModReduction : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 100, value: entity.details && entity.details.mdWageTypeHourModReduction ? entity.details.mdWageTypeHourModReduction : 0, step: 0.25, DisplayLabel: (val) => {
              return val+"";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            let mdWageTypeHourModBool = datafill.entries.find((i) => i.key === "mdWageTypeHourModBool").value;
            let mdWageTypeHourModType = datafill.entries.find((i) => i.key === "mdWageTypeHourModType").value;
            if(!([4, 5].includes(worktype)) && !(worktype === 4 && enumWageTypeId === 47)){
              entryBeforeUpdate.hidden = true;
            } else if (!mdWageTypeHourModBool || !(mdWageTypeHourModType === 3)) {
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.maximum'), key: 'mdWageTypeHourModMaximum',
          hidden: entity.details ? !([4, 5].includes(entity.details.workType) && entity.details.mdWageTypeHourModBool && entity.details.mdWageTypeHourModType === 4) : true,
          type: 'slider',
          value: entity.details && entity.details.mdWageTypeHourModMaximum ? entity.details.mdWageTypeHourModMaximum : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 200, value: entity.details && entity.details.mdWageTypeHourModMaximum ? entity.details.mdWageTypeHourModMaximum : 0, step: 0.25, DisplayLabel: (val) => {
              return val+"";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            let mdWageTypeHourModBool = datafill.entries.find((i) => i.key === "mdWageTypeHourModBool").value;
            let mdWageTypeHourModType = datafill.entries.find((i) => i.key === "mdWageTypeHourModType").value;
            if(!([4, 5].includes(worktype)) && !(worktype === 4 && enumWageTypeId === 47)){
              entryBeforeUpdate.hidden = true;
            } else if (!mdWageTypeHourModBool || !(mdWageTypeHourModType === 4)) {
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.minimum'), key: 'mdWageTypeHourModMinimum',
          hidden: entity.details ? !([4, 5].includes(entity.details.workType) && entity.details.mdWageTypeHourModBool && entity.details.mdWageTypeHourModType === 5) : true,
          type: 'slider',
          value: entity.details && entity.details.mdWageTypeHourModMinimum ? entity.details.mdWageTypeHourModMinimum : 0,
          slider: {hideMin: true, hideMax: true, min: 0, max: 200, value: entity.details && entity.details.mdWageTypeHourModMinimum ? entity.details.mdWageTypeHourModMinimum : 0, step: 0.25, DisplayLabel: (val) => {
              return val+"";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            let mdWageTypeHourModBool = datafill.entries.find((i) => i.key === "mdWageTypeHourModBool").value;
            let mdWageTypeHourModType = datafill.entries.find((i) => i.key === "mdWageTypeHourModType").value;
            if(!([4, 5].includes(worktype)) && !(worktype === 4 && enumWageTypeId === 47)){
              entryBeforeUpdate.hidden = true;
            } else if (!mdWageTypeHourModBool || !(mdWageTypeHourModType === 5)) {
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.modifyHourlyWageFactor'), key: 'mdWageTypeSurchargeBool',
          hidden: entity.details ? !(entity.details.workType === 5) : true,
          type: 'bool',
          value: entity.details && entity.details.mdWageTypeSurchargeBool ? entity.details.mdWageTypeSurchargeBool : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            if(!(worktype === 5)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.modification'), key: 'mdWageTypeSurchargePercentage',
          hidden: entity.details ? !((entity.details.workType === 5) && entity.details.mdWageTypeSurchargeBool) : true,
          type: 'slider',
          value: entity.details && entity.details.mdWageTypeSurchargePercentage ? entity.details.mdWageTypeSurchargePercentage : 100,
          slider: {hideMin: true, hideMax: true, min: 0, max: 400, value: entity.details && entity.details.mdWageTypeSurchargePercentage ? entity.details.mdWageTypeSurchargePercentage : 100, step: 1, DisplayLabel: (val) => {
              return val+"%";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let mdWageTypeSurchargeBool = datafill.entries.find((i) => i.key === "mdWageTypeSurchargeBool").value;
            if(!((worktype === 5) && mdWageTypeSurchargeBool)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        // {
        //   divider: true,
        //   hidden: entity.details ? !(entity.details.workType === 4 && entity.details.enumWageTypeId === 42) : true,
        //   computed: (datafill, lastVal, entryBeforeUpdate) => {
        //     let worktype = datafill.entries.find((i) => i.key === "workType").value;
        //     let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
        //     entryBeforeUpdate.hidden = !(worktype === 4 && enumWageTypeId === 42);
        //     return entryBeforeUpdate;
        //   },
        // },
        {
          label: view.$t('settings.wage.takeNazFromContracts'),
          key: 'dynamicOvertimeUseContractHours',
          hidden: entity.details ? !(entity.details.workType === 4 && entity.details.enumWageTypeId === 42) : true,
          type: "bool",
          value: entity.details ? entity.details.dynamicOvertimeUseContractHours : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            if(!(worktype === 4 && enumWageTypeId === 42)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          },
        },
        {label: view.$t('settings.wage.normalWorkingTimeNaz'), key: 'dynamicOvertimeWorkTimeRegular',
          hidden: entity.details ? !(entity.details.workType === 4 && entity.details.enumWageTypeId === 42 && !entity.details.dynamicOvertimeUseContractHours) : true,
          type: 'slider', value: entity.details && entity.details.dynamicOvertimeWorkTimeRegular ? entity.details.dynamicOvertimeWorkTimeRegular : 169,
          slider: {hideMin: true, hideMax: true, min: 100, max: 200, value: entity.details && entity.details.dynamicOvertimeWorkTimeRegular ? entity.details.dynamicOvertimeWorkTimeRegular : 169, step: 1, DisplayLabel: (val) => {
              return val+"h";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            let useContractHours = datafill.entries.find((i) => i.key === "dynamicOvertimeUseContractHours").value;
            if(!(worktype === 4 && enumWageTypeId === 42 && !useContractHours)){

              entryBeforeUpdate.slider.value = entity.details && entity.details.dynamicOvertimeWorkTimeRegular ? entity.details.dynamicOvertimeWorkTimeRegular : 169;
              entryBeforeUpdate.value = entity.details && entity.details.dynamicOvertimeWorkTimeRegular ? entity.details.dynamicOvertimeWorkTimeRegular : 169;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;

            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.hourBonus'), key: 'dynamicOvertimeBonus',
          hidden: entity.details ? !(entity.details.workType === 4 && entity.details.enumWageTypeId === 42) : true,
          type: 'slider', value: entity.details && entity.details.dynamicOvertimeBonus != null ? entity.details.dynamicOvertimeBonus : 25,
          slider: {hideMin: true, hideMax: true, min: 0, max: 100, value: entity.details && entity.details.dynamicOvertimeBonus != null ? entity.details.dynamicOvertimeBonus : 25, step: 1, DisplayLabel: (val) => {
              return val+"%";
            }, inputControl: true, sliderInput: (x) => { return x }},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            if(!(worktype === 4 && enumWageTypeId === 42)){

              entryBeforeUpdate.slider.value = entity.details && entity.details.dynamicOvertimeBonus != null ? entity.details.dynamicOvertimeBonus : 25;
              entryBeforeUpdate.value = entity.details && entity.details.dynamicOvertimeBonus != null ? entity.details.dynamicOvertimeBonus : 25;
              entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
              entryBeforeUpdate.hidden = true;

            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          }
        },
        {
          label: view.$t('settings.wage.includeProductiveHoursInIst'),
          key: 'dynamicOvertimeIncludeProductiveWorktime',
          hidden: entity.details ? !(entity.details.workType === 4 && entity.details.enumWageTypeId === 42) : true,
          type: "bool",
          value: true,
          disabled: true,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            if(!(worktype === 4 && enumWageTypeId === 42)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }

            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.includeAbsenceTypesInIst'),
          key: 'dynamicOvertimeUnavailabilityTypes',
          hidden: entity.details ? !(entity.details.workType === 4 && (entity.details.enumWageTypeId === 42 || entity.details.enumWageTypeId === 47)) : true,
          type: "dropdownsearch",
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: dynamicOvertimeUnavailabilityTypesList,
            selectMultiple: true,
            selectedItems: [],
            selectedItem: null,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            if(!(worktype === 4 && (enumWageTypeId === 42 || enumWageTypeId === 47))){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('settings.wage.invertSign'),
          key: 'invertSign',
          hidden: entity.details ? !(entity.details.workType === 4 && entity.details.enumWageTypeId === 42) : true,
          type: 'bool',
          value: entity.details != null ? entity.details.invertSign : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            if(!(worktype === 4 && enumWageTypeId === 42)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        {
          label: view.$t('settings.wage.exportOnlyPositives'),
          key: 'exportOnlyPositives',
          hidden: entity.details ? !((entity.details.workType === 4 && entity.details.enumWageTypeId === 42) || entity.details.workType === 5) : true,
          type: 'bool',
          value: entity.details != null ? entity.details.exportOnlyPositives : true,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let worktype = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            if(!((worktype === 4 && enumWageTypeId === 42) || worktype === 5)){
              entryBeforeUpdate.hidden = true;
            } else {
              entryBeforeUpdate.hidden = false;
            }
            return entryBeforeUpdate;
          }
        },
        //{label: 'Sortierungs Priorität', key: 'priority', hidden: false, type: 'slider', value: wt.sorting, slider: {value: wt.sorting, min: 1, max: 100}},
        { // divider
          divider: true,
          hidden: entity.details ? entity.details.workType != 0 : true,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
            if(workType0){
                entryBeforeUpdate.hidden = false;
            } else {
                entryBeforeUpdate.hidden = true;
            }
            return entryBeforeUpdate;
          }
        },
        {
          label: view.$t('settings.wage.applyExclusiveGroup'), key: 'useExclusiveGroup',
          hidden: entity.details ? entity.details.workType != 0 : true,
          type: 'bool',
          value: entity.details != null ? entity.details.exclusiveGroup != null : false,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
            if(workType0){
                entryBeforeUpdate.hidden = false;
            } else {
                entryBeforeUpdate.value = false;
                entryBeforeUpdate.hidden = true;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.exclusiveGroup'), key: 'exclusiveGroup', hidden: entity.details != null ? (entity.details.exclusiveGroup == null || entity.details.workType != 0) : true, type: 'slider', value: entity.details != null ? (entity.details.exclusiveGroup != null ?  entity.details.exclusiveGroup : 1): 1,
          slider: {hideMin: true, hideMax: true, min: 1, max: 10, value: entity.details != null ? (entity.details.exclusiveGroup != null ?  entity.details.exclusiveGroup : 1) : 1,
            step: 1, DisplayLabel: (val) => { return val;}, inputControl: true, sliderInput:(x) => {return x}},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let useExclusiveGroup = datafill.entries.find(i => i.key == 'useExclusiveGroup').value;
            let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
            if(useExclusiveGroup && workType0){
                entryBeforeUpdate.hidden = false;
            } else {
                entryBeforeUpdate.slider.value = 1;
                entryBeforeUpdate.value = 1;
                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                entryBeforeUpdate.hidden = true;
            }
            return entryBeforeUpdate;
          }
        },
        {label: view.$t('settings.wage.priorityInGroup'), key: 'priority', hidden: entity.details != null ? (entity.details.exclusiveGroup == null || entity.details.workType != 0) : true, type: 'slider', value: entity.details != null ? (entity.details.exclusiveGroup != null ?  entity.details.priority : 1): 1,
          slider: {hideMin: true, hideMax: true, min: 1, max: 10, value: entity.details != null ? (entity.details.exclusiveGroup != null ?  entity.details.priority : 1) : 1,
            step: 1, DisplayLabel: (val) => {return val;}, inputControl: true, sliderInput:(x) => {return x}},
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let useExclusiveGroup = datafill.entries.find(i => i.key == 'useExclusiveGroup').value;
            let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
            if(useExclusiveGroup && workType0){
                entryBeforeUpdate.hidden = false;
            } else {
                entryBeforeUpdate.slider.value = 1;
                entryBeforeUpdate.value = 1;
                entryBeforeUpdate.slider = Object.assign({}, entryBeforeUpdate.slider);
                entryBeforeUpdate.hidden = true;
            }
            return entryBeforeUpdate;
          }
        },
        { // divider
          divider: true,
        },
        {
          label: view.$t('settings.wage.showFilters'), key: 'showFilters', hidden: false, type: 'bool',
          value: showFilters,
        },
        {
          label: view.$t('settings.wage.excludeEmployees'), key: 'excludeEmployeeIds', hidden: !showFilters, type: 'bool',
          value: entity.details && entity.details.excludeEmployeeIds ? entity.details.excludeEmployeeIds : false,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: entity.details && entity.details.excludeEmployeeIds ? view.$t('settings.wage.excludeEmployeeTariffGroups') : view.$t('global.ui.employee'),
          key: 'employeeIds', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.employeeIds : null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: employeeItems,
                selectMultiple: true,
                selectedItem: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
                  let excludeEmployeeIds = datafill.entries.find(i => i.key == 'excludeEmployeeIds').value;
                  if(excludeEmployeeIds){
                      entryBeforeUpdate.label = view.$t('settings.wage.excludeEmployeeTariffGroups');
                  } else {
                      entryBeforeUpdate.label = view.$t('global.ui.employee');
                  }
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: view.$t('settings.wage.excludeEmployeeTariffGroups'), key: 'excludeWageGroupIds', hidden: !showFilters, type: 'bool',
          value: entity.details && entity.details.excludeWageGroupIds ? entity.details.excludeWageGroupIds : false,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: entity.details && entity.details.excludeWageGroupIds ? view.$t('settings.wage.allEmployeeTariffGroupsExcept') : view.$t('settings.wage.employeeTariffGroups'),
          key: 'wageGroupIds', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.wageGroupIds : null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: wgItems,
                selectMultiple: true,
                selectedItem: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
                  let excludeWageGroupIds = datafill.entries.find(i => i.key == 'excludeWageGroupIds').value;
                  if(excludeWageGroupIds){
                      entryBeforeUpdate.label = view.$t('settings.wage.allEmployeeTariffGroupsExcept');
                  } else {
                      entryBeforeUpdate.label = view.$t('settings.wage.employeeTariffGroups');
                  }
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: view.$t('settings.wage.excludeEmployeePositions'), key: 'excludeSpotIds', hidden: !showFilters, type: 'bool',
          value: entity.details && entity.details.excludeSpotIds ? entity.details.excludeSpotIds : false,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: entity.details && entity.details.excludeSpotIds ? view.$t('settings.wage.allEmployeePositionsExcept') : view.$t('settings.wage.employeePositions'),
          key: 'spotIds', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.spotIds : null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: spotItems,
                selectMultiple: true,
                selectedItem: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
                  let excludeSpotIds = datafill.entries.find(i => i.key == 'excludeSpotIds').value;
                  if(excludeSpotIds){
                      entryBeforeUpdate.label =  view.$t('settings.wage.allEmployeePositionsExcept');
                  } else {
                      entryBeforeUpdate.label = view.$t('settings.wage.employeePositions');
                  }
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: view.$t('settings.wage.excludeShiftAreas'), key: 'excludeShiftUnitIds', hidden: !showFilters, type: 'bool',
          value: entity.details && entity.details.excludeShiftUnitIds ? entity.details.excludeShiftUnitIds : false,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(workType0 && showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: entity.details && entity.details.excludeShiftUnitIds ? view.$t('settings.wage.allShiftAreasExcept') : view.$t('settings.wage.shiftAreas'),
          key: 'shiftUnitIds',
          hidden: !showFilters,
          type: 'dropdownsearch',
          value: entity.details ? entity.details.shiftUnitIds : null,
          dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: unitItems,
            selectMultiple: true,
            selectedItem: [],
            selectFirst: false,
            styleLight: true,
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
            let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
            if(workType0 && showFilters){
                entryBeforeUpdate.hidden = false;
                let excludeShiftUnitIds = datafill.entries.find(i => i.key == 'excludeShiftUnitIds').value;
                if(excludeShiftUnitIds){
                    entryBeforeUpdate.label = view.$t('settings.wage.allShiftAreasExcept');
                } else {
                    entryBeforeUpdate.label = view.$t('settings.wage.shiftAreas');
                }
            } else {
                entryBeforeUpdate.hidden = true;
                entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                    item.selected = false;
                });
            }
            return entryBeforeUpdate;
          }
        },
        {
          label: view.$t('settings.wage.excludeShiftPositions'), key: 'excludeShiftSpotIds', hidden: !showFilters, type: 'bool',
          value: entity.details && entity.details.excludeShiftSpotIds ? entity.details.excludeShiftSpotIds : false,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(workType0 && showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: entity.details && entity.details.workType == 0 ? (entity.details.excludeSpotIds ? view.$t('settings.wage.allShiftPositionsExcept') : view.$t('settings.wage.shiftPositions'))
            : (entity.details && entity.details.enumWageTypeId === 45 ? view.$t('settings.wage.positions') : view.$t('settings.wage.onCallPositions')),
          key: 'shiftSpotIds',
          hidden: !showFilters,
          type: 'dropdownsearch',
          value: entity.details ? entity.details.shiftSpotIds : null,
          dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: shiftSpotItems,
            selectMultiple: true,
            selectedItem: [],
            selectFirst: false,
            styleLight: true,
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let workType = datafill.entries.find((i) => i.key === "workType").value;
            let enumWageTypeId = datafill.entries.find((i) => i.key === "enumWageTypeId").value;
            let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
            if((workType === 0 && showFilters) || (workType === 4 && (enumWageTypeId === 43 || enumWageTypeId === 44 || enumWageTypeId === 45))){
                entryBeforeUpdate.hidden = false;
                if (workType === 0) {
                  let excludeShiftSpotIds = datafill.entries.find(i => i.key == 'excludeShiftSpotIds').value;
                  if(excludeShiftSpotIds){
                      entryBeforeUpdate.label = view.$t('settings.wage.allShiftPositionsExcept');
                  } else {
                      entryBeforeUpdate.label = view.$t('settings.wage.shiftPositions');
                  }
                } else {
                  if (enumWageTypeId === 45)
                    entryBeforeUpdate.label = view.$t('settings.wage.positions');
                  else {
                    entryBeforeUpdate.label = view.$t('settings.wage.onCallPositions');
                  }
                }
            } else {
                entryBeforeUpdate.hidden = true;
                entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                    item.selected = false;
                });
            }
            return entryBeforeUpdate;
          }
        },
        {
          label: view.$t('settings.wage.excludeShiftLocations'), key: 'excludeFromLocationIds', hidden: !showFilters, type: 'bool',
          value: entity.details && entity.details.excludeFromLocationIds ? entity.details.excludeFromLocationIds : false,
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(workType0 && showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: entity.details && entity.details.excludeFromLocationIds ? view.$t('settings.wage.allShiftLocationsExcept') : view.$t('settings.wage.shiftLocations'),
          key: 'fromLocationIds', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.fromLocationIds : null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: fromLocationItems,
                selectMultiple: true,
                selectedItem: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let workType0 = datafill.entries.find(i => i.key == 'workType').value == 0;
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(workType0 && showFilters){
                  entryBeforeUpdate.hidden = false;
                  let excludeFromLocationIds = datafill.entries.find(i => i.key == 'excludeFromLocationIds').value;
                  if(excludeFromLocationIds){
                      entryBeforeUpdate.label = view.$t('settings.wage.allShiftLocationsExcept');
                  } else {
                      entryBeforeUpdate.label = view.$t('settings.wage.shiftLocations');
                  }
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.contractModel'), key: 'collectiveContractIds', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.collectiveContractId : null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: ccItems,
                selectMultiple: true,
                selectedItem: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.contractTypes'), key: 'contractTypes', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.contractTypes: null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: contractTypeItems,
                selectMultiple: true,
                selectedItems: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.employeeCategories'), key: 'employeeCategories', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.employeeCategories: null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: employeeCategoryItems,
                selectMultiple: true,
                selectedItems: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.employeeLevels'), key: 'employeeLevels', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.employeeLevels: null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: employeeLevelItems,
                selectMultiple: true,
                selectedItems: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.employmentType'), key: 'employmentTypes', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.employmentTypes: null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: employmentTypeItems,
                selectMultiple: true,
                selectedItems: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.allInEmployee'), key: 'allInTypes', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.allInTypes: null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: [
                    { label: view.$t('settings.ui.yes'), value: 1, selected: entity.details && entity.details.allInTypes ? Object.values(entity.details.allInTypes).includes("1") : false },
                    { label: view.$t('settings.ui.no'), value: 0, selected: entity.details && entity.details.allInTypes ? Object.values(entity.details.allInTypes).includes("0") : false }
                ],
                selectMultiple: true,
                selectedItems: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.employeeContractEnded'), key: 'contractEnded', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.contractEnded: null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: [
                    { label: view.$t('settings.ui.yes'), value: 1, selected: entity.details && entity.details.contractEnded ? Object.values(entity.details.contractEnded).includes("1") : false },
                    { label: view.$t('settings.ui.no'), value: 0, selected: entity.details && entity.details.contractEnded ? Object.values(entity.details.contractEnded).includes("0") : false }
                ],
                selectMultiple: true,
                selectedItems: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
            let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
            if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('employee.data.citizenship'), key: 'employeeCitizenShipIds', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.employeeCitizenShipIds: null,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: employeeCitizenShipItems,
                selectMultiple: true,
                selectedItems: [],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
            let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
            if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.dropdownSearchState.items.forEach((item) => {
                      item.selected = false;
                  });
              }
              return entryBeforeUpdate;
            }
        },
        {label: view.$t('settings.wage.conditionJoin'), key: 'conditionJoin', hidden: !showFilters, type: 'dropdownsearch', value: entity.details ? entity.details.conditionJoin: false,
            dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: conditionJoinModes,
                selectMultiple: false,
                selectedItem: entity.details != null && entity.details.conditionJoin != null ? conditionJoinModes.find(c => c.value == entity.details.conditionJoin) : conditionJoinModes[1],
                selectFirst: false,
                styleLight: true,
            },
            computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                  entryBeforeUpdate.hidden = false;
              } else {
                  entryBeforeUpdate.hidden = true;
                  entryBeforeUpdate.value = false;
              }
              return entryBeforeUpdate;
            }
        },
        {
          label: view.$t('settings.wage.applyToYouth'),
          key: 'applyToUnderage',
          hidden: !showFilters,
          type: 'bool',
          value: entity.details != null && entity.details.applyToUnderage != null ? entity.details.applyToUnderage : true,
          computed: (datafill, lastVal, entryBeforeUpdate) => {
              let showFilters = datafill.entries.find(i => i.key == 'showFilters').value;
              if(showFilters){
                entryBeforeUpdate.hidden = false;
            } else {
                entryBeforeUpdate.hidden = true;
                entryBeforeUpdate.value = true;
            }
            return entryBeforeUpdate;
          }
        },
        { flexDivider: true, styles: { "margin-bottom": "23px" } },
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          selectCallback: function (eEntity) {
            let includesNull = eEntity.fromLocationIds && eEntity.fromLocationIds.includes(null);
            eEntity.fromLocationIds = view.storeLocations.filter(l => eEntity.fromLocationIds && eEntity.fromLocationIds.includes(l.name)).map(l => l.id);
            if (includesNull) {
              eEntity.fromLocationIds.push(null);
            }
            // console.log(eEntity.fromLocationIds);
            view.editDetailsEntity(eEntity)
              .then((response) => {
                  view.$helpers.success(
                      view.$t('global.ui.success'),
                      view.$t('settings.wage.wageTypeDetailsUpdated')
                  );
                view.refresh(true);
              })
              .catch(function (error) {
                  view.$helpers.error(
                      view.$t('global.messages.error'),
                      view.$t('settings.wage.wageTypeDetailsUpdateFailed')
                  );
                  console.log(error);
              });
          },
          errorCheck: {
            'weekDays': (entries) => {
              let key = "weekDays";
              let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
              if (!entries['weekDays'] || entries['weekDays'].length < 1) {
                return {
                  key: key,
                  label: label,
                  type: 'error',
                    text: view.$t('settings.wage.selectAtLeastOneWeekday')
                }
              } else {
                return null;
              }
            },
            'maxWorkTime': (entries) => {
              let key = "maxWorkTime";
              let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
              if (entries['useMaxWorkTime'] && entries['maxWorkTime'] <= entries['minWorkTime']) {
                  return {
                    key: key,
                    label: label,
                    type: "error",
                      text: view.$t('settings.wage.maxWorkTimeMustBeGreater')
                  };
              } else {
                return null;
              }
            },
            'checkFrom': (entries) => {
              let key = "checkFrom";
              let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";

              if(entries.useCheckTime) {
                  //check if intervalls overlap
                  let tFrom = entries.timeFrom.clone();
                  let tTo = entries.timeTo.clone();
                  if(tTo <= tFrom){
                      tTo = tTo.add(1, 'days');
                  }
                  let cFrom = entries.checkFrom.clone();
                  let cTo = entries.checkTo.clone();
                  if(cTo <= cFrom){
                      cTo = cTo.add(1, 'days');
                  }
                  if(!(cTo > tFrom && cFrom < tTo)){
                      //no overlap, try checking if there is an overlap if 1 day is subtracted, e.g. in case of 00:00 - 06:00 but check is 19:00 - 07:00
                      cFrom = cFrom.add(-1, 'days');
                      cTo = cTo.add(-1, 'days');
                  }
                  if(!(cTo > tFrom && cFrom < tTo)){
                      //still no overlap (e.g. 00:00 - 06:00 and 07:00 - 14:00) => error
                      return {
                        key: key,
                        label: label,
                        type: 'error',
                          text: view.$t('settings.wage.checkTimeMustOverlapBonusTime')
                      };
                  } else {
                      return null;
                  }


              } else {
                  return null;
              }
            },
            'validFrom': (entries) => {
              let key = "validFrom";
              let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";

              if(entries.workType === 0 && entries.validFrom && entries.validTo && entries.validFrom > entries.validTo){
                  return {
                    key: key,
                    label: label,
                    type: 'error',
                      text: view.$t('settings.wage.validFromMustBeBeforeValidTo')
                  };
              } else {
                  return null;
              }
            },
          },
        },
        header: view.$t('settings.wage.editWageTypeDetails') + " - " + entity.name,
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
    openImportMdBonusPaymentSettings() {
      let view = this;
      view.showModal('modal-loading');
      view.loadMdBonusPaymentSettings()
      .then((response) => {
        view.hideModal('modal-loading');

        let importedBonusPaymentSettings = response.map((bps) => {
          let storeName = view.stores.find(store => store.id == bps.storeId) ? view.stores.find(store => store.id == bps.storeId).name : view.$t('settings.wage.unknownStore');
          return {
            value: bps.id,
            label: bps.name + " (" + storeName + ")"
          };
        });

        let dataEntries = [
          {
            label: view.$t('settings.wage.bonusSetting'),
            key: "bonusPaymentSetting",
            hidden: false,
            type: "dropdownsearch",
            styles: { width: "500px" },
            dropdownSearchState: {
              toggled: false,
              displayedItems: [],
              input: "",
              items: importedBonusPaymentSettings, // This is a map of all stores
              selectMultiple: false,
              selectedItems: [],
              selectedItem: null,
              onceSelected: function ($event, item, searchbar) {},
              styleLight: true,
              placeholder: view.$t('settings.help.pleaseSelect'),
            },
            value: null,
          },
          {
            label: view.$t('settings.wage.applyToAllStores'),
            key: 'enabledAllStores',
            hidden: false,
            type: 'bool',
            value: false,
          },
          {
            label: [2,3,4,5,6].includes(view.externalSoftware) ? "Sotec ID" : view.$t('settings.groups.number'),
            key: "numberString",
            hidden: false,
            type: "text",
            value: "",
            length: 5,
            styles: { width: "500px" },
          },
          {
            label: "Export ID",
            key: "exportId",
            hidden: false,
            type: "text",
            value: "",
            length: 5,
            styles: { width: "500px" },
          },
          {
            label: view.$t('settings.groups.name'),
            key: "name",
            hidden: false,
            type: "text",
            value: "",
            length: 128,
            styles: { width: "500px" },
          },

        ];


        view.$helpers.OpenPopup({
          elRelative: null,
          type: "datafill",
          pointerDirection: 0,
          componentState: {
            entries: dataEntries,
            selectCallback: function (entity) {
              view.createWageTypeAndDetailsFromBonusPaymentSetting(entity);
            },
            errorCheck: {
              bonusPaymentSetting: (entries) => {
                if (entries.bonusPaymentSetting == null) {
                  let key = "bonusPaymentSetting";
                  let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
                  return {
                    key: key,
                    label: label,
                    type: "error",
                    text: view.$t('settings.wage.pleaseSelect'),
                  };
                } else {
                  return null;
                }
              },
              // numberString: (entries) => {
              //   if (entries.numberString == undefined || view.individualWageTypes.find((f) => f.numberString+"" === entries.numberString+"")) {
              //     let key = "numberString";
              //     let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
              //     return {
              //       key: key,
              //       label: label,
              //       type: "error",
              //       text: "Wird bereits verwendet",
              //     };
              //   } else {
              //     return null;
              //   }
              // },
              name: (entries) => {
                let key = "name";
                let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
                if (entries.name == undefined || entries.name == "") {
                  return {
                    key: key,
                    label: label,
                    type: "error",
                    text: view.$t('settings.wage.pleaseFillOut'),
                  };
                } else if (view.individualWageTypes.find((f) => f.name.toLowerCase() === entries.name.toLowerCase())) {
                  return {
                    key: key,
                    label: label,
                    type: "error",
                    text: view.$t('settings.groups.errAlreadyUsed'),
                  };
                } else {
                  return null;
                }
              },
            },
          },
          header: "Neue Lohnart anlegen",
          remainAfterSelect: false,
          centered: true,
          expanded: true,
        });
      })
      .catch((error) => {
        view.hideModal('modal-loading');
        view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.bonusSettingsLoadFailed'));
        console.log(error);
      });
    },
    openImportBonusPaymentSettingsFromCompanySelect() {
      let view = this;

      let items = Object.values(this.companyArray).filter(c => ""+c.id !== ""+this.companyId).map((company) => {
              return {
                value: company.id,
                label: company.name,
              };
            });

      let dataEntries = [
        {
          label: "Company",
          key: "companyId",
          hidden: false,
          type: "dropdownsearch",
          styles: { width: "500px" },
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: items,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: items && items.length > 0 ? items[0] : null,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          value: null,
        },
      ];


      view.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          selectCallback: function (entity) {
            view.openImportBonusPaymentSettingsFromCompany(entity.companyId);
          },
          errorCheck: {
            companyId: (entries) => {
              if (entries.companyId == null) {
                let key = "companyId";
                let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
                return {
                  key: key,
                  label: label,
                  type: "error",
                  text: view.$t('settings.wage.pleaseSelect'),
                };
              } else {
                return null;
              }
            }
          },
        },
        header: view.$t('settings.wage.selectCompanyForImport'),
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
    openImportBonusPaymentSettingsFromCompany(companyId) {
      let view = this;

      view.showModal('modal-loading');
      view.loadBonusPaymentSettingsFromCompany(companyId)
      .then((response) => {
        view.hideModal('modal-loading');

        // console.log(response);

        let importedBonusPaymentSettings = response.map((bps) => {
          let storeName = view.stores.find(store => store.id == bps.storeId) ? view.stores.find(store => store.id == bps.storeId).name : view.$t('settings.wage.unknownStore');
          return {
            value: bps.id,
            label: bps.name
          };
        });

        let dataEntries = [
          {
            label: view.$t('settings.wage.bonusSetting'),
            key: "bonusPaymentSetting",
            hidden: false,
            type: "dropdownsearch",
            styles: { width: "500px" },
            dropdownSearchState: {
              toggled: false,
              displayedItems: [],
              input: "",
              items: importedBonusPaymentSettings, // This is a map of all stores
              selectMultiple: true,
              selectedItems: [],
              selectedItem: null,
              onceSelected: function ($event, item, searchbar) {},
              styleLight: true,
              placeholder: view.$t('settings.help.pleaseSelect'),
            },
            value: null,
          },

        ];


        view.$helpers.OpenPopup({
          elRelative: null,
          type: "datafill",
          pointerDirection: 0,
          componentState: {
            entries: dataEntries,
            selectCallback: function (entity) {
              view.cloneIndividualWageTypes(entity.bonusPaymentSetting);
            },
            errorCheck: {
              bonusPaymentSetting: (entries) => {
                // console.log(entries.bonusPaymentSetting);
                if (entries.bonusPaymentSetting.length == 0) {
                  let key = "bonusPaymentSetting";
                  let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
                  return {
                    key: key,
                    label: label,
                    type: "error",
                    text: view.$t('settings.wage.pleaseSelect'),
                  };
                // } else if (view.individualWageTypes.find((f) => f.name.toLowerCase() === entries.name.toLowerCase())) {
                //   return {
                //     key: key,
                //     label: label,
                //     type: "error",
                //     text: "Wird bereits verwendet",
                //   };
                } else {
                  let selectedBonusPaymentSettingNames = entries.bonusPaymentSetting.map((bpsId) => {
                    return importedBonusPaymentSettings.find((bps) => bps.value == bpsId).label;
                  });
                  if (view.individualWageTypes.find((f) => selectedBonusPaymentSettingNames.includes(f.name))) {
                    // console.log(view.individualWageTypes.find((f) => selectedBonusPaymentSettingNames.includes(f.name)));
                    let key = "bonusPaymentSetting";
                    let label = view.individualWageTypes.find((f) => selectedBonusPaymentSettingNames.includes(f.name)).name;
                    return {
                      key: key,
                      label: label,
                      type: "error",
                      text: view.$t('settings.groups.errAlreadyUsed'),
                    };
                  }
                  return null;
                }
              },
            },
          },
          header: view.$t('settings.wage.importWageType'),
          remainAfterSelect: false,
          centered: true,
          expanded: true,
        });
      })
      .catch((error) => {
        view.hideModal('modal-loading');
        view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.bonusSettingsLoadFailed'));
        console.log(error);
      });
    },
    openDeleteIwtPopup(eEntity) {
      let view = this;

        let description = view.$t('settings.wage.confirmDeleteWageType', { name: eEntity.name });

        this.$helpers.OpenPopup({
        elRelative: event.currentTarget,
        width: '500px',
        type: 'datafill',
        pointerDirection: 0,
        componentState: {
          entries: [],
          description: description,
          positiveButtonLabel: view.$t('settings.notes.delete'),
          selectCallback: function (form) {
            view.deleteEntity(eEntity);
          },
          negativeButtonLabel: view.$t('settings.ui.cancel'),
          deleteCallback: function (form) {
          }
        },
        header: this.$t('settings.wage.deleteWageType'),
        remainAfterSelect: false,
        expanded: true,
        centered: true,
      });
    },
    openRestoreIwtPopup() {
      let view = this;

      // console.log(view.individualWageTypesTrashed);

      let dataEntries = [
        { label: this.$t('settings.wage.wageType'), key: "id", hidden: false, type: "dropdownsearch",
          dropdownSearchState:{
            toggled: false,
            displayedItems: [],
            input: '',
            items: view.individualWageTypesTrashed.map((iwt) => { return { label: iwt.name, value: iwt.id }; }),
            selectMultiple: false,
            selectedItems: [],
            selectedItem: null,
            onceSelected: function($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          value: null,
        },
        { flexDivider: true, styles: { "margin-bottom": "23px" } },
        {
          label: "Export ID",
          key: "exportId",
          hidden: true,
          disabled: true,
          type: "text",
          value: "",
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let selectedId = datafill.entries.find((i) => i.key == 'id').value;
            let selectedIwt = view.individualWageTypesTrashed.find((iwt) => iwt.id == selectedId);
            entryBeforeUpdate.value = selectedIwt ? selectedIwt.exportId : "";
            entryBeforeUpdate.hidden = false;
            return entryBeforeUpdate;
          }
        },
        {
          label: view.$t('settings.wage.deletedAt'),
          key: "deletedAt",
          hidden: true,
          disabled: true,
          type: "text",
          value: "",
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let selectedId = datafill.entries.find((i) => i.key == 'id').value;
            let selectedIwt = view.individualWageTypesTrashed.find((iwt) => iwt.id == selectedId);
            entryBeforeUpdate.value = selectedIwt ? view.$helpers.getMomentFromStringTZ(selectedIwt.deleted_at, "YYYY-MM-DDTHH:mm:ssZ").format('DD.MM.YYYY HH:mm:ss') : "";
            entryBeforeUpdate.hidden = false;
            return entryBeforeUpdate;
          }
        }
      ];

      this.$helpers.OpenPopup({
        elRelative: event.currentTarget,
        width: '600px',
        type: 'datafill',
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          positiveButtonLabel: view.$t('settings.wage.restore'),
          selectCallback: function (entity) {
            view.restoreEntity(entity.id);
          },
          negativeButtonLabel: view.$t('settings.ui.cancel'),
          deleteCallback: function (entity) {
          },
          errorCheck: {
            'id': (entries) => {
              let key = "id";
              let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
              if (!entries['id'] || entries['id'] == null) {
                return {
                  key: key,
                  label: label,
                  type: 'error',
                  text: view.$t('settings.wage.selectWageType')
                }
              } else {
                return null;
              }
            },
          },
        },
        header: view.$t('settings.wage.restoreWageTypes'),
        remainAfterSelect: false,
        expanded: true,
        centered: true,
      });
    },


    createIndividualWageType(newWageType) {
      let view = this;
      view.sendCreateIndividualWageType(newWageType)
        .then((response) => {
          view.$helpers.success(
            view.$t('settings.wage.wageTypeCreated'),
            view.$t('settings.wage.wageTypeCreated')
          );
          view.refresh(true);
        })
        .catch(function (error) {
          view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.wageTypeCreateFailed'));
          console.log(error);
        });
    },
    sendCreateIndividualWageType(newWageType) {
      let view = this;
      let url = "/api/sec/individualWageTypes";
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/individualWageTypes"
      );
      let payload = {
        companyId: this.$store.state.companyId,
        numberString: newWageType.numberString,
        exportId: newWageType.exportId,
        name: newWageType.name,
        priority: 0, //newWageType.priority,
      };
      return this.axios({
        method: "post",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      });
    },
    editEntity(editWageType) {
      let view = this;
      let url = "/api/sec/individualWageTypes/" + editWageType.id;
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/individualWageTypes/" + editWageType.id
      );
      let payload = {
        companyId: this.$store.state.companyId,
        numberString: editWageType.numberString,
        exportId: editWageType.exportId,
        name: editWageType.name,
        priority: 0, //editWageType.priority,
      };
      this.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
          view.$helpers.success(
              view.$t('settings.wage.wageTypeUpdated'),
              view.$t('settings.wage.wageTypeUpdated')
          );
          view.refresh(true);
        })
        .catch(function (error) {
          view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.wageTypeUpdateFailed'));
          console.log(error);
        });
    },
    deleteEntity(editWageType) {
      let view = this;
      let url = "/api/sec/individualWageTypes/" + editWageType.id;
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/individualWageTypes/" + editWageType.id
      );
      this.axios({
        method: "delete",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url
      })
        .then((response) => {
          view.$helpers.success(
            view.$t('settings.wage.wageTypeDeleted'),
            view.$t('settings.wage.wageTypeDeleted')
          );
          view.refresh(true);
        })
        .catch(function (error) {
          view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.wageTypeDeleteFailed'));
          console.log(error);
        });
    },
    restoreEntity(restoreId) {
      let view = this;
      let url = "/api/sec/individualWageTypes/restore/" + restoreId;
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/individualWageTypes/restore/" + restoreId
      );
      this.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url
      })
        .then((response) => {
          view.$helpers.success(
            view.$t('settings.wage.wageTypeRestored'),
            view.$t('settings.wage.wageTypeRestored'),
          );
          view.refresh(true);
        })
        .catch(function (error) {
          view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.wageTypeRestoreFailed'));
          console.log(error);
        });
    },
    editDetailsEntity(entity) {
      console.log("entity", entity);
      let view = this;

      let url = "";
      let method = "";
      if (entity.id) {
        url = "/api/sec/individualWageTypeDetails/" + entity.id;
        url = this.$helpers.appendParam(
          "companyId",
          this.$store.state.companyId,
          url,
          "/api/sec/individualWageTypeDetails/" + entity.id
        );
        method = "put";
      } else {
        url = "/api/sec/individualWageTypeDetails";
        url = this.$helpers.appendParam(
          "companyId",
          this.$store.state.companyId,
          url,
          "/api/sec/individualWageTypeDetails"
        );
        method = "post";
      }

      if (!entity.useExclusiveGroup) {
        entity.exclusiveGroup = null;
        entity.priority = null;
      }

      entity.companyId = this.$store.state.companyId;
      entity.timeFrom = entity.timeFrom.format("HH:mm");
      entity.timeTo = entity.timeTo.format("HH:mm");
      entity.checkFrom = entity.checkFrom && entity.useCheckTime ? entity.checkFrom.format("HH:mm") : null;
      entity.checkTo = entity.checkTo && entity.useCheckTime ? entity.checkTo.format("HH:mm") : null;

      let payload = entity;

      return this.axios({
        method: method,
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      });
    },
    createWageTypeAndDetailsFromBonusPaymentSetting(entity) {
      let view = this;

      let bonusPaymentSetting = view.mdBonusPaymentSettings.find(bps => bps.id == entity.bonusPaymentSetting);
      if (!bonusPaymentSetting) {
        view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.bonusSettingsApplyFailed'));
        return;
      }

      // build wage type details from bonusPaymentSetting
      let wageType = {
        numberString: entity.numberString,
        exportId: entity.exportId,
        name: entity.name,
      };
      let wageTypeDetail = {
        workType: 0,
        weekDays: bonusPaymentSetting.weekDays,
        holidays: bonusPaymentSetting.holidayMode,
        holidayTypes: bonusPaymentSetting.holidayTypes,
        timeFrom: view.$helpers.getMomentFromStringTZ(bonusPaymentSetting.bonusFrom, "HH:mm"),
        timeTo: view.$helpers.getMomentFromStringTZ(bonusPaymentSetting.bonusTo, "HH:mm"),
        useBonus: 2,
        useHourlyWage: bonusPaymentSetting.useHourlyWage,
        hourlyWagePercentage: bonusPaymentSetting.hourlyWagePercentage,
        bonusHour: bonusPaymentSetting.bonusHour,
        bonusShift: bonusPaymentSetting.bonusShift,
        bonusMode: bonusPaymentSetting.bonusMode,
        useWageGroup: false,
        wageGroupId: null,
        hourlyWage: 0,
        bonusCutoff: bonusPaymentSetting.bonusCutoff,
        minWorkTime: bonusPaymentSetting.minWorkTime,
        useMaxWorkTime: bonusPaymentSetting.maxWorkTime != null,
        maxWorkTime: bonusPaymentSetting.maxWorkTime ? bonusPaymentSetting.maxWorkTime : 0,
        excludeBreaksFromWorkTime: 0,
        checkFrom: view.$helpers.getMomentFromStringTZ(bonusPaymentSetting.checkFrom, "HH:mm"),
        checkTo: view.$helpers.getMomentFromStringTZ(bonusPaymentSetting.checkTo, "HH:mm"),
        enabledAllStores: entity.enabledAllStores,
        enabledStores: [bonusPaymentSetting.storeId], // set store of current setting if not enabled for all stores
        includeInSum: 0,
        validFrom: bonusPaymentSetting.from,
        validTo: bonusPaymentSetting.to,
        useExclusiveGroup: bonusPaymentSetting.exclusiveGroup != null && bonusPaymentSetting.priority != null,
        exclusiveGroup: bonusPaymentSetting.exclusiveGroup,
        priority: bonusPaymentSetting.priority,
        excludeEmployeeIds: false,
        employeeIds: [],
        collectiveContractIds: bonusPaymentSetting.collectiveContractId ? [bonusPaymentSetting.collectiveContractId] : [],
        excludeWageGroupIds: false,
        wageGroupIds: [],
        spotIds: bonusPaymentSetting.spotId ? [bonusPaymentSetting.spotId] : [],
        shiftUnitIds: [],
        shiftSpotIds: bonusPaymentSetting.shiftSpotId ? [bonusPaymentSetting.shiftSpotId] : [],
        fromLocationIds: bonusPaymentSetting.fromLocationId ? [bonusPaymentSetting.fromLocationId] : [],
        contractTypes: bonusPaymentSetting.contractTypes,
        employeeCategories: bonusPaymentSetting.employeeCategories,
        employeeLevels: bonusPaymentSetting.employeeLevels,
        employmentTypes: bonusPaymentSetting.employmentTypes,
        conditionJoin: bonusPaymentSetting.conditionJoin,
        applyToUnderage: bonusPaymentSetting.applyToUnderage,
        startsWithin: bonusPaymentSetting.startsWithin,
        extraCostPercentage: 0,
        useAverages: 0,
        useAverageWage: 0,
        overwritePaymentWithZero: 0,
        dynamicOvertimeUseContractHours: 0,
        unavailabilitySubTypes: [],
        dynamicOvertimeUnavailabilityTypes: [],
        extraCostTypes: [],
        bonusExpenseTypes: [],
        allInTypes: [],
        contractEnded: [],
        employeeCitizenShipIds: [],
      };

      // console.log(wageTypeDetail);

      view.sendCreateIndividualWageType(wageType)
        .then((response) => {
          // console.log(response.data);
          wageTypeDetail.wageTypeId = response.data.id;
          // console.log(wageTypeDetail);
          view.editDetailsEntity(wageTypeDetail)
            .then((response) => {
              view.$helpers.success(view.$t('global.ui.success'), view.$t('settings.wage.bonusSettingsAppliedSuccessfully'));
              view.refresh(true);
            })
            .catch((error) => {
              view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.wageTypeDetailsCreateFailed'));
              console.log(error);
            });
        })
        .catch((error) => {
          view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.wageTypeCreateFailed'));
          console.log(error);
        });
    },
    cloneIndividualWageTypes(iwtIds) {
      console.log("cloning iwtIds... ",  iwtIds);

      let view = this;
      let url = "/api/sec/individualWageTypes/clone";
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/individualWageTypes/clone"
      );
      let payload = {
        iwtIds: iwtIds,
      };

      return this.axios({
        method: "post",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
        data: payload
      })
        .then((response) => {
          view.$helpers.success(
              view.$t('settings.wage.wageTypesCopied'),
              view.$t('settings.wage.wageTypesCopied')
          );
          view.refresh(true);
        })
        .catch(function (error) {
          console.log(error);
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.wage.wageTypesCopyFailed')
          );
        });
    },

    toggleColorPicker(wageType, val = null) {
      let view = this;
      this.$helpers.OpenColorSelection(
        (color) => {
          wageType.color = color;
          view.saveColor(wageType);
        },
        {
          colorSelected: wageType.color,
          colorBlacklist: this.individualWageTypes.map((s) => {
            return { color: s.color, label: s.name };
          }),
        }
      );
    },
    OpenFilterDropdown() {
      var view = this;

      this.$helpers.OpenPopup({
        type: "list",
        componentState: {
          entries: view.filterDropdownOptions,
        },
        remainAfterSelect: true,
        pointerDirection: 0,
        iconsLeft: true,
        selectCallback: function ($event, item, dropdown) {
          item.toggled = !item.toggled;
          view.refreshFilteredList++;
        },
      });
    },
    LoadFilterDropdown() {
      var view = this;
      if (view.filterDropdownOptions.length > 0) return;
      view.filterDropdownOptions.push({
        label: view.$t('settings.wage.noLocations'),
        key: "none",
        toggled: true
      });

      view.stores.forEach((store) => {
        view.filterDropdownOptions.push({
          label: store.name,
          key: store.id,
          toggled: true
        });
      });
    },
    saveColor(myObj) {
      let view = this;
      let url = "/api/sec/individualWageTypes/" + myObj.id;
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/individualWageTypes/" + myObj.id
      );
      let payload = {
        companyId: this.$store.state.companyId,
        color: myObj.color,
      };
      this.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
          view.$helpers.success(
              view.$t('settings.wage.colorChanged'),
              view.$t('settings.wage.colorChanged')
          );
          view.refresh(true);
        })
        .catch(function (error) {
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('settings.wage.colorChangeFailed')
          );
          console.log(error);
        });
    },
    setupUIDataMaps() {
      // console.log(this.uiDataMap);
      if (!this.uiDataMap.employeeCategories) {
        this.$helpers.GetUiDataMap()
          .then((response) => {
            // this.uiDataMap = response;
            this.setupUIDataMaps();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.uiDataMap.employeeCategories.forEach(item => this.employeeCategoryMap[item.id] = item.label_de);
        this.uiDataMap.employeeLevels.forEach(item => this.employeeLevelMap[item.id] = item.label_de);
        this.uiDataMap.contractTypes.forEach(item => this.contractTypeMap[item.id] = item.label_de);
        this.uiDataMap.employmentTypes.forEach(item => this.employmentTypeMap[item.id] = item.label_de);
        this.uiDataMap.paymentTypes.forEach(item => this.paymentTypeMap[item.id] = item.label_de);
        this.uiDataMap.wageTypes.forEach(item => this.wageTypeMap[item.id] = item.label_de);
        this.uiDataMap.nightWorkerTypes.forEach(item => this.nightWorkerTypeMap[item.id] = item.label_de);
        this.uiDataMap.nightWorkModes.forEach(item => this.nightWorkModeMap[item.id] = item.label_de);
        this.uiDataMap.exitReasons.forEach(item => this.exitReasonMap[item.id] = item.label_de);
      }
    },
    sort(sortBy) {
    	if(this.sortBy === sortBy) {
      	this.sortOrder = -this.sortOrder;
      } else {
      	this.sortBy = sortBy;
        this.sortOrder = 1;
      }
      this.refreshFilteredList++;
    },
    printStoreNames(storeIds) {
      // console.log(storeIds);
      let view = this;
      if (JSON.parse(storeIds).length === 1) {
        let store = view.stores.find(s => s.id == JSON.parse(storeIds)[0]);
        return store ? store.name : "1 " + view.$t('settings.centers.location');
      }
      return ((JSON.parse(storeIds).length) + " " +  view.$t('settings.wage.locations'));
    },

    showModal(ref) {
      this.$refs[ref].show()
    },
    hideModal(ref) {
      this.$refs[ref].hide()
    },
  },
};
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.name-filter .fa-search {
  color: var(--contrast-4);
  position: absolute;
  top: 5px;
  left: 5px;
}

.half-width {
  width: 50%;
}

.fix-button-width {
  width: 150px;
}

.filter-input {
  margin-left: -45px;
  padding-left: 40px;
  width: calc(100% - 25px);
}

.list {
  width: calc(100% - 78px);
  margin: auto;
  height: 265px;
  box-shadow: inset 0 0 0 1px var(--contrast-3);
  overflow: hidden;
  position: absolute;
  border-radius: 5px;
}
.list .scroll-content {
  padding: 5px;
  overflow-y: auto;
  height: 265px;
}

.list-entry {
  height: 35px;
  margin-bottom: 2px;
  border-radius: 100px;
  cursor: pointer;
}

.list-entry:hover {
  background: var(--sub-menu);
  cursor: pointer;
}
.list-entry.selected {
  background: #e51550;
  cursor: pointer;
}
.list-entry.selected > .label,
.list-entry:hover > .label {
  color: var(--bg);
  cursor: pointer;
}
.list-entry.selected > .label > .label-small,
.list-entry.hover > .label > .label-small {
  color: var(--bg) !important;
  cursor: pointer;
}

.list-entry > .label {
  float: left;
  font-size: 14px;
  font-family: DistrictProBook;
  color: var(--contrast-4);
  padding-top: 6px;
  cursor: pointer;
}
.list-entry > .label > .label-small {
  cursor: pointer;
  color: var(--contrast-5);
}

.picture {
  float: left;
  border-radius: 100px;
  background: var(--contrast-1);
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 10px;
  height: 25px;
  width: 25px;
}
.position-right {
  float: right;
  margin: 0;
  margin-right: -5px;
}
.pictureImg {
  border-radius: 100px;
  height: 25px;
  width: 25px;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--contrast-1);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--contrast-3);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #aaaaaa;
}
.has-header > .has-header > .scrollbar-container {
  height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
  overflow-x: hidden;
  top: var(--header-height);
  padding: 0px 14px;
}
</style>
